// source: users_entity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var karaoke_entity_pb = require('./karaoke_entity_pb.js');
goog.object.extend(proto, karaoke_entity_pb);
var leagues_entity_pb = require('./leagues_entity_pb.js');
goog.object.extend(proto, leagues_entity_pb);
var live_mode_entity_pb = require('./live_mode_entity_pb.js');
goog.object.extend(proto, live_mode_entity_pb);
var master_violation_entity_pb = require('./master/violation_entity_pb.js');
goog.object.extend(proto, master_violation_entity_pb);
var photo_entity_pb = require('./photo_entity_pb.js');
goog.object.extend(proto, photo_entity_pb);
goog.exportSymbol('proto.jp.singcolor.AcquireDiamondCondition', null, global);
goog.exportSymbol('proto.jp.singcolor.AcquiredDiamondDetail', null, global);
goog.exportSymbol('proto.jp.singcolor.AdhocEvent', null, global);
goog.exportSymbol('proto.jp.singcolor.AdhocEventDivision', null, global);
goog.exportSymbol('proto.jp.singcolor.AdhocEventDivisionHoldingStatus', null, global);
goog.exportSymbol('proto.jp.singcolor.AdhocEventHoldingStatus', null, global);
goog.exportSymbol('proto.jp.singcolor.AvailableClosingTime', null, global);
goog.exportSymbol('proto.jp.singcolor.Ban', null, global);
goog.exportSymbol('proto.jp.singcolor.Blocking', null, global);
goog.exportSymbol('proto.jp.singcolor.CanFindGoodLiversAnswer', null, global);
goog.exportSymbol('proto.jp.singcolor.DayOfLiverTerm', null, global);
goog.exportSymbol('proto.jp.singcolor.DefaultTimelineID', null, global);
goog.exportSymbol('proto.jp.singcolor.Device', null, global);
goog.exportSymbol('proto.jp.singcolor.EnterPreviewSongSetting', null, global);
goog.exportSymbol('proto.jp.singcolor.FanType', null, global);
goog.exportSymbol('proto.jp.singcolor.Follower', null, global);
goog.exportSymbol('proto.jp.singcolor.Following', null, global);
goog.exportSymbol('proto.jp.singcolor.GearType', null, global);
goog.exportSymbol('proto.jp.singcolor.Gender', null, global);
goog.exportSymbol('proto.jp.singcolor.HiddenLiver', null, global);
goog.exportSymbol('proto.jp.singcolor.InterestedLiver', null, global);
goog.exportSymbol('proto.jp.singcolor.IsSingFeelingAppAnswer', null, global);
goog.exportSymbol('proto.jp.singcolor.ListenerMembershipInfo', null, global);
goog.exportSymbol('proto.jp.singcolor.ListenerSongFaveThumbnail', null, global);
goog.exportSymbol('proto.jp.singcolor.ListenerViewingStanceToAvoid', null, global);
goog.exportSymbol('proto.jp.singcolor.LiverEvaluationCriterionAvoidance', null, global);
goog.exportSymbol('proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel', null, global);
goog.exportSymbol('proto.jp.singcolor.LiverEvaluationCriterionImportance', null, global);
goog.exportSymbol('proto.jp.singcolor.LiverRequestedSongHistory', null, global);
goog.exportSymbol('proto.jp.singcolor.Moderator', null, global);
goog.exportSymbol('proto.jp.singcolor.MonthlyStatisticsPageKey', null, global);
goog.exportSymbol('proto.jp.singcolor.NotificationType', null, global);
goog.exportSymbol('proto.jp.singcolor.PearlCup', null, global);
goog.exportSymbol('proto.jp.singcolor.PearlCupDivision', null, global);
goog.exportSymbol('proto.jp.singcolor.PearlCupDivisionHoldingStatus', null, global);
goog.exportSymbol('proto.jp.singcolor.PearlCupDivisionWithPrize', null, global);
goog.exportSymbol('proto.jp.singcolor.PearlCupGearOption', null, global);
goog.exportSymbol('proto.jp.singcolor.PearlCupPrize', null, global);
goog.exportSymbol('proto.jp.singcolor.PearlCupPrize.Condition', null, global);
goog.exportSymbol('proto.jp.singcolor.PearlCupPrize.Condition.Amount', null, global);
goog.exportSymbol('proto.jp.singcolor.Prefecture', null, global);
goog.exportSymbol('proto.jp.singcolor.RankingLiver', null, global);
goog.exportSymbol('proto.jp.singcolor.RankingTerm', null, global);
goog.exportSymbol('proto.jp.singcolor.RankingTermType', null, global);
goog.exportSymbol('proto.jp.singcolor.RequestStoreReviewDisplayState', null, global);
goog.exportSymbol('proto.jp.singcolor.SearchUser', null, global);
goog.exportSymbol('proto.jp.singcolor.SingScoreFilterOption', null, global);
goog.exportSymbol('proto.jp.singcolor.SingScoreFilterSuggestion', null, global);
goog.exportSymbol('proto.jp.singcolor.StatisticsRecord', null, global);
goog.exportSymbol('proto.jp.singcolor.Town', null, global);
goog.exportSymbol('proto.jp.singcolor.TwitterAccount', null, global);
goog.exportSymbol('proto.jp.singcolor.UnreadNotificationInfo', null, global);
goog.exportSymbol('proto.jp.singcolor.User', null, global);
goog.exportSymbol('proto.jp.singcolor.UserBanHistory', null, global);
goog.exportSymbol('proto.jp.singcolor.UserBirthday', null, global);
goog.exportSymbol('proto.jp.singcolor.UserBlock', null, global);
goog.exportSymbol('proto.jp.singcolor.UserDevice', null, global);
goog.exportSymbol('proto.jp.singcolor.UserFlag', null, global);
goog.exportSymbol('proto.jp.singcolor.UserFollow', null, global);
goog.exportSymbol('proto.jp.singcolor.UserFollowCount', null, global);
goog.exportSymbol('proto.jp.singcolor.UserItem', null, global);
goog.exportSymbol('proto.jp.singcolor.UserItemWithFavePoint', null, global);
goog.exportSymbol('proto.jp.singcolor.UserItemWithFollow', null, global);
goog.exportSymbol('proto.jp.singcolor.UserLiveClosingTime', null, global);
goog.exportSymbol('proto.jp.singcolor.UserProfile', null, global);
goog.exportSymbol('proto.jp.singcolor.UserProfileScreening', null, global);
goog.exportSymbol('proto.jp.singcolor.UserSingHistoryClip', null, global);
goog.exportSymbol('proto.jp.singcolor.UserSingRange', null, global);
goog.exportSymbol('proto.jp.singcolor.UserTimelineVisibilityExclusion', null, global);
goog.exportSymbol('proto.jp.singcolor.UserWithListenerSongFaveThumbnail', null, global);
goog.exportSymbol('proto.jp.singcolor.UserWithdraw', null, global);
goog.exportSymbol('proto.jp.singcolor.UserWithdrawalStatus', null, global);
goog.exportSymbol('proto.jp.singcolor.ViewingArea', null, global);
goog.exportSymbol('proto.jp.singcolor.ViewingAreaInfo', null, global);
goog.exportSymbol('proto.jp.singcolor.ViewingStance', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.User.displayName = 'proto.jp.singcolor.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.UserItem.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.UserItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserItem.displayName = 'proto.jp.singcolor.UserItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserWithListenerSongFaveThumbnail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserWithListenerSongFaveThumbnail.displayName = 'proto.jp.singcolor.UserWithListenerSongFaveThumbnail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserProfile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserProfile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserProfile.displayName = 'proto.jp.singcolor.UserProfile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserBirthday = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserBirthday, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserBirthday.displayName = 'proto.jp.singcolor.UserBirthday';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserFlag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserFlag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserFlag.displayName = 'proto.jp.singcolor.UserFlag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserFollow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserFollow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserFollow.displayName = 'proto.jp.singcolor.UserFollow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserFollowCount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserFollowCount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserFollowCount.displayName = 'proto.jp.singcolor.UserFollowCount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserBlock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserBlock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserBlock.displayName = 'proto.jp.singcolor.UserBlock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserWithdraw = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserWithdraw, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserWithdraw.displayName = 'proto.jp.singcolor.UserWithdraw';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.ViewingAreaInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.ViewingAreaInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.ViewingAreaInfo.displayName = 'proto.jp.singcolor.ViewingAreaInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Prefecture = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Prefecture, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Prefecture.displayName = 'proto.jp.singcolor.Prefecture';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Town = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Town, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Town.displayName = 'proto.jp.singcolor.Town';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.TwitterAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.TwitterAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.TwitterAccount.displayName = 'proto.jp.singcolor.TwitterAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Following = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Following, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Following.displayName = 'proto.jp.singcolor.Following';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Follower = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Follower, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Follower.displayName = 'proto.jp.singcolor.Follower';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Blocking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Blocking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Blocking.displayName = 'proto.jp.singcolor.Blocking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserBanHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.UserBanHistory.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.UserBanHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserBanHistory.displayName = 'proto.jp.singcolor.UserBanHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Ban = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Ban, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Ban.displayName = 'proto.jp.singcolor.Ban';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserProfileScreening = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.UserProfileScreening.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.UserProfileScreening, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserProfileScreening.displayName = 'proto.jp.singcolor.UserProfileScreening';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserItemWithFollow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserItemWithFollow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserItemWithFollow.displayName = 'proto.jp.singcolor.UserItemWithFollow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.SearchUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.SearchUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.SearchUser.displayName = 'proto.jp.singcolor.SearchUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserItemWithFavePoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserItemWithFavePoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserItemWithFavePoint.displayName = 'proto.jp.singcolor.UserItemWithFavePoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.RankingLiver = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.RankingLiver, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.RankingLiver.displayName = 'proto.jp.singcolor.RankingLiver';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.RankingTerm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.RankingTerm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.RankingTerm.displayName = 'proto.jp.singcolor.RankingTerm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UnreadNotificationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UnreadNotificationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UnreadNotificationInfo.displayName = 'proto.jp.singcolor.UnreadNotificationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.AcquireDiamondCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.AcquireDiamondCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.AcquireDiamondCondition.displayName = 'proto.jp.singcolor.AcquireDiamondCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.MonthlyStatisticsPageKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.MonthlyStatisticsPageKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.MonthlyStatisticsPageKey.displayName = 'proto.jp.singcolor.MonthlyStatisticsPageKey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.AcquiredDiamondDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.AcquiredDiamondDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.AcquiredDiamondDetail.displayName = 'proto.jp.singcolor.AcquiredDiamondDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.StatisticsRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.StatisticsRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.StatisticsRecord.displayName = 'proto.jp.singcolor.StatisticsRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.DayOfLiverTerm = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.DayOfLiverTerm, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.DayOfLiverTerm.displayName = 'proto.jp.singcolor.DayOfLiverTerm';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.AvailableClosingTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.AvailableClosingTime.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.AvailableClosingTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.AvailableClosingTime.displayName = 'proto.jp.singcolor.AvailableClosingTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserLiveClosingTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserLiveClosingTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserLiveClosingTime.displayName = 'proto.jp.singcolor.UserLiveClosingTime';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.PearlCup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.PearlCup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.PearlCup.displayName = 'proto.jp.singcolor.PearlCup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.PearlCupDivision = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.PearlCupDivision, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.PearlCupDivision.displayName = 'proto.jp.singcolor.PearlCupDivision';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.PearlCupDivisionWithPrize = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.PearlCupDivisionWithPrize, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.PearlCupDivisionWithPrize.displayName = 'proto.jp.singcolor.PearlCupDivisionWithPrize';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.PearlCupPrize = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.PearlCupPrize, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.PearlCupPrize.displayName = 'proto.jp.singcolor.PearlCupPrize';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.PearlCupPrize.Condition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.PearlCupPrize.Condition.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.PearlCupPrize.Condition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.PearlCupPrize.Condition.displayName = 'proto.jp.singcolor.PearlCupPrize.Condition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.PearlCupPrize.Condition.Amount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.PearlCupPrize.Condition.Amount.displayName = 'proto.jp.singcolor.PearlCupPrize.Condition.Amount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.AdhocEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.AdhocEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.AdhocEvent.displayName = 'proto.jp.singcolor.AdhocEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.AdhocEventDivision = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.AdhocEventDivision, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.AdhocEventDivision.displayName = 'proto.jp.singcolor.AdhocEventDivision';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.PearlCupGearOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.PearlCupGearOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.PearlCupGearOption.displayName = 'proto.jp.singcolor.PearlCupGearOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserDevice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserDevice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserDevice.displayName = 'proto.jp.singcolor.UserDevice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Device = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Device, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Device.displayName = 'proto.jp.singcolor.Device';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.LiverRequestedSongHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.LiverRequestedSongHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.LiverRequestedSongHistory.displayName = 'proto.jp.singcolor.LiverRequestedSongHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.ListenerMembershipInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.ListenerMembershipInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.ListenerMembershipInfo.displayName = 'proto.jp.singcolor.ListenerMembershipInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.Moderator = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.Moderator, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.Moderator.displayName = 'proto.jp.singcolor.Moderator';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.ListenerSongFaveThumbnail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.ListenerSongFaveThumbnail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.ListenerSongFaveThumbnail.displayName = 'proto.jp.singcolor.ListenerSongFaveThumbnail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.LiverEvaluationCriterionImportance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.LiverEvaluationCriterionImportance.displayName = 'proto.jp.singcolor.LiverEvaluationCriterionImportance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.jp.singcolor.LiverEvaluationCriterionAvoidance.repeatedFields_, null);
};
goog.inherits(proto.jp.singcolor.LiverEvaluationCriterionAvoidance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.LiverEvaluationCriterionAvoidance.displayName = 'proto.jp.singcolor.LiverEvaluationCriterionAvoidance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.SingScoreFilterOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.SingScoreFilterOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.SingScoreFilterOption.displayName = 'proto.jp.singcolor.SingScoreFilterOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.SingScoreFilterSuggestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.SingScoreFilterSuggestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.SingScoreFilterSuggestion.displayName = 'proto.jp.singcolor.SingScoreFilterSuggestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.displayName = 'proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserTimelineVisibilityExclusion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserTimelineVisibilityExclusion.displayName = 'proto.jp.singcolor.UserTimelineVisibilityExclusion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.InterestedLiver = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.InterestedLiver, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.InterestedLiver.displayName = 'proto.jp.singcolor.InterestedLiver';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.HiddenLiver = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.HiddenLiver, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.HiddenLiver.displayName = 'proto.jp.singcolor.HiddenLiver';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.EnterPreviewSongSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.EnterPreviewSongSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.EnterPreviewSongSetting.displayName = 'proto.jp.singcolor.EnterPreviewSongSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserSingHistoryClip = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserSingHistoryClip, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserSingHistoryClip.displayName = 'proto.jp.singcolor.UserSingHistoryClip';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.jp.singcolor.UserSingRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.jp.singcolor.UserSingRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.jp.singcolor.UserSingRange.displayName = 'proto.jp.singcolor.UserSingRange';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.User.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    profileImageUrls: (f = msg.getProfileImageUrls()) && photo_entity_pb.ImageURL.toObject(includeInstance, f),
    createdAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    displayUserId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.User}
 */
proto.jp.singcolor.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.User;
  return proto.jp.singcolor.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.User}
 */
proto.jp.singcolor.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = new photo_entity_pb.ImageURL;
      reader.readMessage(value,photo_entity_pb.ImageURL.deserializeBinaryFromReader);
      msg.setProfileImageUrls(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfileImageUrls();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      photo_entity_pb.ImageURL.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getDisplayUserId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.User.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.User} returns this
 */
proto.jp.singcolor.User.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.jp.singcolor.User.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.User} returns this
 */
proto.jp.singcolor.User.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ImageURL profile_image_urls = 4;
 * @return {?proto.jp.singcolor.ImageURL}
 */
proto.jp.singcolor.User.prototype.getProfileImageUrls = function() {
  return /** @type{?proto.jp.singcolor.ImageURL} */ (
    jspb.Message.getWrapperField(this, photo_entity_pb.ImageURL, 4));
};


/**
 * @param {?proto.jp.singcolor.ImageURL|undefined} value
 * @return {!proto.jp.singcolor.User} returns this
*/
proto.jp.singcolor.User.prototype.setProfileImageUrls = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.User} returns this
 */
proto.jp.singcolor.User.prototype.clearProfileImageUrls = function() {
  return this.setProfileImageUrls(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.User.prototype.hasProfileImageUrls = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 created_at = 5;
 * @return {number}
 */
proto.jp.singcolor.User.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.User} returns this
 */
proto.jp.singcolor.User.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 updated_at = 6;
 * @return {number}
 */
proto.jp.singcolor.User.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.User} returns this
 */
proto.jp.singcolor.User.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string display_user_id = 7;
 * @return {string}
 */
proto.jp.singcolor.User.prototype.getDisplayUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.User} returns this
 */
proto.jp.singcolor.User.prototype.setDisplayUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.UserItem.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserItem.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    user: (f = msg.getUser()) && proto.jp.singcolor.User.toObject(includeInstance, f),
    userProfile: (f = msg.getUserProfile()) && proto.jp.singcolor.UserProfile.toObject(includeInstance, f),
    leagueType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    leagueTypeName: jspb.Message.getFieldWithDefault(msg, 11, ""),
    leagueId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    redioMode: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    singersList: jspb.Message.toObjectList(msg.getSingersList(),
    karaoke_entity_pb.Singer.toObject, includeInstance),
    closingTime: (f = msg.getClosingTime()) && proto.jp.singcolor.UserLiveClosingTime.toObject(includeInstance, f),
    createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.UserItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserItem;
  return proto.jp.singcolor.UserItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.UserItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.User;
      reader.readMessage(value,proto.jp.singcolor.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new proto.jp.singcolor.UserProfile;
      reader.readMessage(value,proto.jp.singcolor.UserProfile.deserializeBinaryFromReader);
      msg.setUserProfile(value);
      break;
    case 4:
      var value = /** @type {!proto.jp.singcolor.LeagueType} */ (reader.readEnum());
      msg.setLeagueType(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeagueTypeName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeagueId(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRedioMode(value);
      break;
    case 7:
      var value = new karaoke_entity_pb.Singer;
      reader.readMessage(value,karaoke_entity_pb.Singer.deserializeBinaryFromReader);
      msg.addSingers(value);
      break;
    case 8:
      var value = new proto.jp.singcolor.UserLiveClosingTime;
      reader.readMessage(value,proto.jp.singcolor.UserLiveClosingTime.deserializeBinaryFromReader);
      msg.setClosingTime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.User.serializeBinaryToWriter
    );
  }
  f = message.getUserProfile();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.jp.singcolor.UserProfile.serializeBinaryToWriter
    );
  }
  f = message.getLeagueType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLeagueTypeName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLeagueId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRedioMode();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getSingersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      karaoke_entity_pb.Singer.serializeBinaryToWriter
    );
  }
  f = message.getClosingTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.jp.singcolor.UserLiveClosingTime.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserItem.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional User user = 2;
 * @return {?proto.jp.singcolor.User}
 */
proto.jp.singcolor.UserItem.prototype.getUser = function() {
  return /** @type{?proto.jp.singcolor.User} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.User, 2));
};


/**
 * @param {?proto.jp.singcolor.User|undefined} value
 * @return {!proto.jp.singcolor.UserItem} returns this
*/
proto.jp.singcolor.UserItem.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserItem.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UserProfile user_profile = 3;
 * @return {?proto.jp.singcolor.UserProfile}
 */
proto.jp.singcolor.UserItem.prototype.getUserProfile = function() {
  return /** @type{?proto.jp.singcolor.UserProfile} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserProfile, 3));
};


/**
 * @param {?proto.jp.singcolor.UserProfile|undefined} value
 * @return {!proto.jp.singcolor.UserItem} returns this
*/
proto.jp.singcolor.UserItem.prototype.setUserProfile = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.clearUserProfile = function() {
  return this.setUserProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserItem.prototype.hasUserProfile = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional LeagueType league_type = 4;
 * @return {!proto.jp.singcolor.LeagueType}
 */
proto.jp.singcolor.UserItem.prototype.getLeagueType = function() {
  return /** @type {!proto.jp.singcolor.LeagueType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.jp.singcolor.LeagueType} value
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.setLeagueType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string league_type_name = 11;
 * @return {string}
 */
proto.jp.singcolor.UserItem.prototype.getLeagueTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.setLeagueTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 league_id = 5;
 * @return {number}
 */
proto.jp.singcolor.UserItem.prototype.getLeagueId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.setLeagueId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool redio_mode = 6;
 * @return {boolean}
 */
proto.jp.singcolor.UserItem.prototype.getRedioMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.setRedioMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated Singer singers = 7;
 * @return {!Array<!proto.jp.singcolor.Singer>}
 */
proto.jp.singcolor.UserItem.prototype.getSingersList = function() {
  return /** @type{!Array<!proto.jp.singcolor.Singer>} */ (
    jspb.Message.getRepeatedWrapperField(this, karaoke_entity_pb.Singer, 7));
};


/**
 * @param {!Array<!proto.jp.singcolor.Singer>} value
 * @return {!proto.jp.singcolor.UserItem} returns this
*/
proto.jp.singcolor.UserItem.prototype.setSingersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.jp.singcolor.Singer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.Singer}
 */
proto.jp.singcolor.UserItem.prototype.addSingers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.jp.singcolor.Singer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.clearSingersList = function() {
  return this.setSingersList([]);
};


/**
 * optional UserLiveClosingTime closing_time = 8;
 * @return {?proto.jp.singcolor.UserLiveClosingTime}
 */
proto.jp.singcolor.UserItem.prototype.getClosingTime = function() {
  return /** @type{?proto.jp.singcolor.UserLiveClosingTime} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserLiveClosingTime, 8));
};


/**
 * @param {?proto.jp.singcolor.UserLiveClosingTime|undefined} value
 * @return {!proto.jp.singcolor.UserItem} returns this
*/
proto.jp.singcolor.UserItem.prototype.setClosingTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.clearClosingTime = function() {
  return this.setClosingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserItem.prototype.hasClosingTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.jp.singcolor.UserItem.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 updated_at = 10;
 * @return {number}
 */
proto.jp.singcolor.UserItem.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserItem} returns this
 */
proto.jp.singcolor.UserItem.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserWithListenerSongFaveThumbnail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    user: (f = msg.getUser()) && proto.jp.singcolor.User.toObject(includeInstance, f),
    listenerSongFaveThumbnail: (f = msg.getListenerSongFaveThumbnail()) && proto.jp.singcolor.ListenerSongFaveThumbnail.toObject(includeInstance, f),
    viewingAreaInfo: (f = msg.getViewingAreaInfo()) && proto.jp.singcolor.ViewingAreaInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserWithListenerSongFaveThumbnail;
  return proto.jp.singcolor.UserWithListenerSongFaveThumbnail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.User;
      reader.readMessage(value,proto.jp.singcolor.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new proto.jp.singcolor.ListenerSongFaveThumbnail;
      reader.readMessage(value,proto.jp.singcolor.ListenerSongFaveThumbnail.deserializeBinaryFromReader);
      msg.setListenerSongFaveThumbnail(value);
      break;
    case 4:
      var value = new proto.jp.singcolor.ViewingAreaInfo;
      reader.readMessage(value,proto.jp.singcolor.ViewingAreaInfo.deserializeBinaryFromReader);
      msg.setViewingAreaInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserWithListenerSongFaveThumbnail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.User.serializeBinaryToWriter
    );
  }
  f = message.getListenerSongFaveThumbnail();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.jp.singcolor.ListenerSongFaveThumbnail.serializeBinaryToWriter
    );
  }
  f = message.getViewingAreaInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.jp.singcolor.ViewingAreaInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} returns this
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional User user = 2;
 * @return {?proto.jp.singcolor.User}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.getUser = function() {
  return /** @type{?proto.jp.singcolor.User} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.User, 2));
};


/**
 * @param {?proto.jp.singcolor.User|undefined} value
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} returns this
*/
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} returns this
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ListenerSongFaveThumbnail listener_song_fave_thumbnail = 3;
 * @return {?proto.jp.singcolor.ListenerSongFaveThumbnail}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.getListenerSongFaveThumbnail = function() {
  return /** @type{?proto.jp.singcolor.ListenerSongFaveThumbnail} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.ListenerSongFaveThumbnail, 3));
};


/**
 * @param {?proto.jp.singcolor.ListenerSongFaveThumbnail|undefined} value
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} returns this
*/
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.setListenerSongFaveThumbnail = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} returns this
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.clearListenerSongFaveThumbnail = function() {
  return this.setListenerSongFaveThumbnail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.hasListenerSongFaveThumbnail = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ViewingAreaInfo viewing_area_info = 4;
 * @return {?proto.jp.singcolor.ViewingAreaInfo}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.getViewingAreaInfo = function() {
  return /** @type{?proto.jp.singcolor.ViewingAreaInfo} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.ViewingAreaInfo, 4));
};


/**
 * @param {?proto.jp.singcolor.ViewingAreaInfo|undefined} value
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} returns this
*/
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.setViewingAreaInfo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserWithListenerSongFaveThumbnail} returns this
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.clearViewingAreaInfo = function() {
  return this.setViewingAreaInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserWithListenerSongFaveThumbnail.prototype.hasViewingAreaInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserProfile.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserProfile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserProfile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserProfile.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bio: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 3, 0),
    url: jspb.Message.getFieldWithDefault(msg, 4, ""),
    twitterId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    twitterUrl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    twitterUrlForExternalBrowser: jspb.Message.getFieldWithDefault(msg, 20, ""),
    tiktokId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    tiktokUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
    youtubeHandle: jspb.Message.getFieldWithDefault(msg, 9, ""),
    youtubeUrl: jspb.Message.getFieldWithDefault(msg, 10, ""),
    instagramId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    instagramUrl: jspb.Message.getFieldWithDefault(msg, 12, ""),
    prefecture: (f = msg.getPrefecture()) && proto.jp.singcolor.Prefecture.toObject(includeInstance, f),
    town: (f = msg.getTown()) && proto.jp.singcolor.Town.toObject(includeInstance, f),
    tag1: jspb.Message.getFieldWithDefault(msg, 15, ""),
    tag2: jspb.Message.getFieldWithDefault(msg, 16, ""),
    tag3: jspb.Message.getFieldWithDefault(msg, 17, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 18, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 19, 0),
    isGenderHidden: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    isEnterPreviewEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    isEnterPreviewEnabledAsLiver: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    isEnterPreviewSongSettingEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 24, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserProfile}
 */
proto.jp.singcolor.UserProfile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserProfile;
  return proto.jp.singcolor.UserProfile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserProfile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserProfile}
 */
proto.jp.singcolor.UserProfile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBio(value);
      break;
    case 3:
      var value = /** @type {!proto.jp.singcolor.Gender} */ (reader.readEnum());
      msg.setGender(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTwitterId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTwitterUrl(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setTwitterUrlForExternalBrowser(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTiktokId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setTiktokUrl(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setYoutubeHandle(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setYoutubeUrl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstagramId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstagramUrl(value);
      break;
    case 13:
      var value = new proto.jp.singcolor.Prefecture;
      reader.readMessage(value,proto.jp.singcolor.Prefecture.deserializeBinaryFromReader);
      msg.setPrefecture(value);
      break;
    case 14:
      var value = new proto.jp.singcolor.Town;
      reader.readMessage(value,proto.jp.singcolor.Town.deserializeBinaryFromReader);
      msg.setTown(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag1(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag2(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setTag3(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGenderHidden(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnterPreviewEnabled(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnterPreviewEnabledAsLiver(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEnterPreviewSongSettingEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserProfile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserProfile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserProfile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserProfile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBio();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGender();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTwitterId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTwitterUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTwitterUrlForExternalBrowser();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getTiktokId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTiktokUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getYoutubeHandle();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getYoutubeUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getInstagramId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getInstagramUrl();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPrefecture();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.jp.singcolor.Prefecture.serializeBinaryToWriter
    );
  }
  f = message.getTown();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.jp.singcolor.Town.serializeBinaryToWriter
    );
  }
  f = message.getTag1();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTag2();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTag3();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getIsGenderHidden();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getIsEnterPreviewEnabled();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getIsEnterPreviewEnabledAsLiver();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getIsEnterPreviewSongSettingEnabled();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string bio = 2;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getBio = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setBio = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Gender gender = 3;
 * @return {!proto.jp.singcolor.Gender}
 */
proto.jp.singcolor.UserProfile.prototype.getGender = function() {
  return /** @type {!proto.jp.singcolor.Gender} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.jp.singcolor.Gender} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setGender = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string twitter_id = 5;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getTwitterId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setTwitterId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string twitter_url = 6;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getTwitterUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setTwitterUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string twitter_url_for_external_browser = 20;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getTwitterUrlForExternalBrowser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setTwitterUrlForExternalBrowser = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string tiktok_id = 7;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getTiktokId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setTiktokId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string tiktok_url = 8;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getTiktokUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setTiktokUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string youtube_handle = 9;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getYoutubeHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setYoutubeHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string youtube_url = 10;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getYoutubeUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setYoutubeUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string instagram_id = 11;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getInstagramId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setInstagramId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string instagram_url = 12;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getInstagramUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setInstagramUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional Prefecture prefecture = 13;
 * @return {?proto.jp.singcolor.Prefecture}
 */
proto.jp.singcolor.UserProfile.prototype.getPrefecture = function() {
  return /** @type{?proto.jp.singcolor.Prefecture} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.Prefecture, 13));
};


/**
 * @param {?proto.jp.singcolor.Prefecture|undefined} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
*/
proto.jp.singcolor.UserProfile.prototype.setPrefecture = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.clearPrefecture = function() {
  return this.setPrefecture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserProfile.prototype.hasPrefecture = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Town town = 14;
 * @return {?proto.jp.singcolor.Town}
 */
proto.jp.singcolor.UserProfile.prototype.getTown = function() {
  return /** @type{?proto.jp.singcolor.Town} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.Town, 14));
};


/**
 * @param {?proto.jp.singcolor.Town|undefined} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
*/
proto.jp.singcolor.UserProfile.prototype.setTown = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.clearTown = function() {
  return this.setTown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserProfile.prototype.hasTown = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string tag1 = 15;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getTag1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setTag1 = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string tag2 = 16;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getTag2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setTag2 = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string tag3 = 17;
 * @return {string}
 */
proto.jp.singcolor.UserProfile.prototype.getTag3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setTag3 = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int64 created_at = 18;
 * @return {number}
 */
proto.jp.singcolor.UserProfile.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 updated_at = 19;
 * @return {number}
 */
proto.jp.singcolor.UserProfile.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional bool is_gender_hidden = 21;
 * @return {boolean}
 */
proto.jp.singcolor.UserProfile.prototype.getIsGenderHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setIsGenderHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool is_enter_preview_enabled = 22;
 * @return {boolean}
 */
proto.jp.singcolor.UserProfile.prototype.getIsEnterPreviewEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setIsEnterPreviewEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool is_enter_preview_enabled_as_liver = 23;
 * @return {boolean}
 */
proto.jp.singcolor.UserProfile.prototype.getIsEnterPreviewEnabledAsLiver = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setIsEnterPreviewEnabledAsLiver = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool is_enter_preview_song_setting_enabled = 24;
 * @return {boolean}
 */
proto.jp.singcolor.UserProfile.prototype.getIsEnterPreviewSongSettingEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserProfile} returns this
 */
proto.jp.singcolor.UserProfile.prototype.setIsEnterPreviewSongSettingEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserBirthday.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserBirthday.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserBirthday} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserBirthday.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ageId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    birthday: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isMinor: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    createdAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserBirthday}
 */
proto.jp.singcolor.UserBirthday.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserBirthday;
  return proto.jp.singcolor.UserBirthday.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserBirthday} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserBirthday}
 */
proto.jp.singcolor.UserBirthday.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAgeId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBirthday(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMinor(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserBirthday.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserBirthday.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserBirthday} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserBirthday.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAgeId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBirthday();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsMinor();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserBirthday.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserBirthday} returns this
 */
proto.jp.singcolor.UserBirthday.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 age_id = 2;
 * @return {number}
 */
proto.jp.singcolor.UserBirthday.prototype.getAgeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserBirthday} returns this
 */
proto.jp.singcolor.UserBirthday.prototype.setAgeId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string birthday = 3;
 * @return {string}
 */
proto.jp.singcolor.UserBirthday.prototype.getBirthday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserBirthday} returns this
 */
proto.jp.singcolor.UserBirthday.prototype.setBirthday = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_minor = 4;
 * @return {boolean}
 */
proto.jp.singcolor.UserBirthday.prototype.getIsMinor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserBirthday} returns this
 */
proto.jp.singcolor.UserBirthday.prototype.setIsMinor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int64 created_at = 5;
 * @return {number}
 */
proto.jp.singcolor.UserBirthday.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserBirthday} returns this
 */
proto.jp.singcolor.UserBirthday.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 updated_at = 6;
 * @return {number}
 */
proto.jp.singcolor.UserBirthday.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserBirthday} returns this
 */
proto.jp.singcolor.UserBirthday.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserFlag.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserFlag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserFlag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserFlag.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isQa: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    isAntisocialForces: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    isCautionNeeded: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    isPermittedToUseOrganization: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    isPayTaxIncludedWithoutInvoice: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserFlag}
 */
proto.jp.singcolor.UserFlag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserFlag;
  return proto.jp.singcolor.UserFlag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserFlag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserFlag}
 */
proto.jp.singcolor.UserFlag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsQa(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAntisocialForces(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCautionNeeded(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPermittedToUseOrganization(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPayTaxIncludedWithoutInvoice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserFlag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserFlag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserFlag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserFlag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsQa();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIsAntisocialForces();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIsCautionNeeded();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getIsPermittedToUseOrganization();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsPayTaxIncludedWithoutInvoice();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserFlag.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserFlag} returns this
 */
proto.jp.singcolor.UserFlag.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_qa = 4;
 * @return {boolean}
 */
proto.jp.singcolor.UserFlag.prototype.getIsQa = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserFlag} returns this
 */
proto.jp.singcolor.UserFlag.prototype.setIsQa = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool is_antisocial_forces = 5;
 * @return {boolean}
 */
proto.jp.singcolor.UserFlag.prototype.getIsAntisocialForces = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserFlag} returns this
 */
proto.jp.singcolor.UserFlag.prototype.setIsAntisocialForces = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool is_caution_needed = 6;
 * @return {boolean}
 */
proto.jp.singcolor.UserFlag.prototype.getIsCautionNeeded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserFlag} returns this
 */
proto.jp.singcolor.UserFlag.prototype.setIsCautionNeeded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool is_permitted_to_use_organization = 9;
 * @return {boolean}
 */
proto.jp.singcolor.UserFlag.prototype.getIsPermittedToUseOrganization = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserFlag} returns this
 */
proto.jp.singcolor.UserFlag.prototype.setIsPermittedToUseOrganization = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool is_pay_tax_included_without_invoice = 10;
 * @return {boolean}
 */
proto.jp.singcolor.UserFlag.prototype.getIsPayTaxIncludedWithoutInvoice = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserFlag} returns this
 */
proto.jp.singcolor.UserFlag.prototype.setIsPayTaxIncludedWithoutInvoice = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserFollow.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserFollow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserFollow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserFollow.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isFollowing: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    isNotificationOn: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserFollow}
 */
proto.jp.singcolor.UserFollow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserFollow;
  return proto.jp.singcolor.UserFollow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserFollow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserFollow}
 */
proto.jp.singcolor.UserFollow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFollowing(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsNotificationOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserFollow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserFollow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserFollow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserFollow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsFollowing();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIsNotificationOn();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserFollow.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserFollow} returns this
 */
proto.jp.singcolor.UserFollow.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_following = 2;
 * @return {boolean}
 */
proto.jp.singcolor.UserFollow.prototype.getIsFollowing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserFollow} returns this
 */
proto.jp.singcolor.UserFollow.prototype.setIsFollowing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool is_notification_on = 3;
 * @return {boolean}
 */
proto.jp.singcolor.UserFollow.prototype.getIsNotificationOn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserFollow} returns this
 */
proto.jp.singcolor.UserFollow.prototype.setIsNotificationOn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserFollowCount.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserFollowCount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserFollowCount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserFollowCount.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    followingCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    followerCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserFollowCount}
 */
proto.jp.singcolor.UserFollowCount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserFollowCount;
  return proto.jp.singcolor.UserFollowCount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserFollowCount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserFollowCount}
 */
proto.jp.singcolor.UserFollowCount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFollowingCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFollowerCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserFollowCount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserFollowCount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserFollowCount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserFollowCount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFollowingCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFollowerCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserFollowCount.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserFollowCount} returns this
 */
proto.jp.singcolor.UserFollowCount.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 following_count = 2;
 * @return {number}
 */
proto.jp.singcolor.UserFollowCount.prototype.getFollowingCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserFollowCount} returns this
 */
proto.jp.singcolor.UserFollowCount.prototype.setFollowingCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 follower_count = 3;
 * @return {number}
 */
proto.jp.singcolor.UserFollowCount.prototype.getFollowerCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserFollowCount} returns this
 */
proto.jp.singcolor.UserFollowCount.prototype.setFollowerCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserBlock.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserBlock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserBlock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserBlock.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isBlocking: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    isBlocked: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserBlock}
 */
proto.jp.singcolor.UserBlock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserBlock;
  return proto.jp.singcolor.UserBlock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserBlock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserBlock}
 */
proto.jp.singcolor.UserBlock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBlocking(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBlocked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserBlock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserBlock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserBlock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserBlock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsBlocking();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIsBlocked();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserBlock.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserBlock} returns this
 */
proto.jp.singcolor.UserBlock.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_blocking = 2;
 * @return {boolean}
 */
proto.jp.singcolor.UserBlock.prototype.getIsBlocking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserBlock} returns this
 */
proto.jp.singcolor.UserBlock.prototype.setIsBlocking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool is_blocked = 3;
 * @return {boolean}
 */
proto.jp.singcolor.UserBlock.prototype.getIsBlocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserBlock} returns this
 */
proto.jp.singcolor.UserBlock.prototype.setIsBlocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserWithdraw.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserWithdraw.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserWithdraw} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserWithdraw.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isWithdraw: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserWithdraw}
 */
proto.jp.singcolor.UserWithdraw.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserWithdraw;
  return proto.jp.singcolor.UserWithdraw.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserWithdraw} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserWithdraw}
 */
proto.jp.singcolor.UserWithdraw.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsWithdraw(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserWithdraw.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserWithdraw.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserWithdraw} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserWithdraw.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsWithdraw();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserWithdraw.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserWithdraw} returns this
 */
proto.jp.singcolor.UserWithdraw.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_withdraw = 2;
 * @return {boolean}
 */
proto.jp.singcolor.UserWithdraw.prototype.getIsWithdraw = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserWithdraw} returns this
 */
proto.jp.singcolor.UserWithdraw.prototype.setIsWithdraw = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.ViewingAreaInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.ViewingAreaInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.ViewingAreaInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.ViewingAreaInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    viewingArea: jspb.Message.getFieldWithDefault(msg, 1, 0),
    distantStandingNumber: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.ViewingAreaInfo}
 */
proto.jp.singcolor.ViewingAreaInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.ViewingAreaInfo;
  return proto.jp.singcolor.ViewingAreaInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.ViewingAreaInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.ViewingAreaInfo}
 */
proto.jp.singcolor.ViewingAreaInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.jp.singcolor.ViewingArea} */ (reader.readEnum());
      msg.setViewingArea(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistantStandingNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.ViewingAreaInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.ViewingAreaInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.ViewingAreaInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.ViewingAreaInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewingArea();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDistantStandingNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional ViewingArea viewing_area = 1;
 * @return {!proto.jp.singcolor.ViewingArea}
 */
proto.jp.singcolor.ViewingAreaInfo.prototype.getViewingArea = function() {
  return /** @type {!proto.jp.singcolor.ViewingArea} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.jp.singcolor.ViewingArea} value
 * @return {!proto.jp.singcolor.ViewingAreaInfo} returns this
 */
proto.jp.singcolor.ViewingAreaInfo.prototype.setViewingArea = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 distant_standing_number = 2;
 * @return {number}
 */
proto.jp.singcolor.ViewingAreaInfo.prototype.getDistantStandingNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.ViewingAreaInfo} returns this
 */
proto.jp.singcolor.ViewingAreaInfo.prototype.setDistantStandingNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Prefecture.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Prefecture.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Prefecture} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Prefecture.toObject = function(includeInstance, msg) {
  var f, obj = {
    prefectureId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Prefecture}
 */
proto.jp.singcolor.Prefecture.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Prefecture;
  return proto.jp.singcolor.Prefecture.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Prefecture} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Prefecture}
 */
proto.jp.singcolor.Prefecture.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrefectureId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Prefecture.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Prefecture.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Prefecture} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Prefecture.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrefectureId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 prefecture_id = 1;
 * @return {number}
 */
proto.jp.singcolor.Prefecture.prototype.getPrefectureId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Prefecture} returns this
 */
proto.jp.singcolor.Prefecture.prototype.setPrefectureId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.jp.singcolor.Prefecture.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Prefecture} returns this
 */
proto.jp.singcolor.Prefecture.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Town.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Town.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Town} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Town.toObject = function(includeInstance, msg) {
  var f, obj = {
    townId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    prefectureId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Town}
 */
proto.jp.singcolor.Town.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Town;
  return proto.jp.singcolor.Town.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Town} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Town}
 */
proto.jp.singcolor.Town.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTownId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrefectureId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Town.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Town.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Town} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Town.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTownId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrefectureId();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 town_id = 1;
 * @return {number}
 */
proto.jp.singcolor.Town.prototype.getTownId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Town} returns this
 */
proto.jp.singcolor.Town.prototype.setTownId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.jp.singcolor.Town.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Town} returns this
 */
proto.jp.singcolor.Town.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 prefecture_id = 3;
 * @return {number}
 */
proto.jp.singcolor.Town.prototype.getPrefectureId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Town} returns this
 */
proto.jp.singcolor.Town.prototype.setPrefectureId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.TwitterAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.TwitterAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.TwitterAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.TwitterAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    twitterUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    screenName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    profileImageUrl: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.TwitterAccount}
 */
proto.jp.singcolor.TwitterAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.TwitterAccount;
  return proto.jp.singcolor.TwitterAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.TwitterAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.TwitterAccount}
 */
proto.jp.singcolor.TwitterAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTwitterUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setScreenName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfileImageUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.TwitterAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.TwitterAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.TwitterAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.TwitterAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTwitterUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScreenName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProfileImageUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string twitter_user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.TwitterAccount.prototype.getTwitterUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.TwitterAccount} returns this
 */
proto.jp.singcolor.TwitterAccount.prototype.setTwitterUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.jp.singcolor.TwitterAccount.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.TwitterAccount} returns this
 */
proto.jp.singcolor.TwitterAccount.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string screen_name = 3;
 * @return {string}
 */
proto.jp.singcolor.TwitterAccount.prototype.getScreenName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.TwitterAccount} returns this
 */
proto.jp.singcolor.TwitterAccount.prototype.setScreenName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string profile_image_url = 4;
 * @return {string}
 */
proto.jp.singcolor.TwitterAccount.prototype.getProfileImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.TwitterAccount} returns this
 */
proto.jp.singcolor.TwitterAccount.prototype.setProfileImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Following.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Following.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Following} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Following.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    targetUserItem: (f = msg.getTargetUserItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    lastFollowedAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    targetUserFollow: (f = msg.getTargetUserFollow()) && proto.jp.singcolor.UserFollow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Following}
 */
proto.jp.singcolor.Following.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Following;
  return proto.jp.singcolor.Following.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Following} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Following}
 */
proto.jp.singcolor.Following.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setTargetUserItem(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastFollowedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 6:
      var value = new proto.jp.singcolor.UserFollow;
      reader.readMessage(value,proto.jp.singcolor.UserFollow.deserializeBinaryFromReader);
      msg.setTargetUserFollow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Following.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Following.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Following} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Following.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetUserItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getLastFollowedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getTargetUserFollow();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.jp.singcolor.UserFollow.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.Following.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Following} returns this
 */
proto.jp.singcolor.Following.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UserItem target_user_item = 2;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.Following.prototype.getTargetUserItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 2));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.Following} returns this
*/
proto.jp.singcolor.Following.prototype.setTargetUserItem = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Following} returns this
 */
proto.jp.singcolor.Following.prototype.clearTargetUserItem = function() {
  return this.setTargetUserItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Following.prototype.hasTargetUserItem = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 last_followed_at = 3;
 * @return {number}
 */
proto.jp.singcolor.Following.prototype.getLastFollowedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Following} returns this
 */
proto.jp.singcolor.Following.prototype.setLastFollowedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.jp.singcolor.Following.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Following} returns this
 */
proto.jp.singcolor.Following.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.jp.singcolor.Following.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Following} returns this
 */
proto.jp.singcolor.Following.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional UserFollow target_user_follow = 6;
 * @return {?proto.jp.singcolor.UserFollow}
 */
proto.jp.singcolor.Following.prototype.getTargetUserFollow = function() {
  return /** @type{?proto.jp.singcolor.UserFollow} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserFollow, 6));
};


/**
 * @param {?proto.jp.singcolor.UserFollow|undefined} value
 * @return {!proto.jp.singcolor.Following} returns this
*/
proto.jp.singcolor.Following.prototype.setTargetUserFollow = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Following} returns this
 */
proto.jp.singcolor.Following.prototype.clearTargetUserFollow = function() {
  return this.setTargetUserFollow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Following.prototype.hasTargetUserFollow = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Follower.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Follower.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Follower} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Follower.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    targetUserItem: (f = msg.getTargetUserItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    lastFollowedAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    targetUserFollow: (f = msg.getTargetUserFollow()) && proto.jp.singcolor.UserFollow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Follower}
 */
proto.jp.singcolor.Follower.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Follower;
  return proto.jp.singcolor.Follower.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Follower} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Follower}
 */
proto.jp.singcolor.Follower.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setTargetUserItem(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastFollowedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 6:
      var value = new proto.jp.singcolor.UserFollow;
      reader.readMessage(value,proto.jp.singcolor.UserFollow.deserializeBinaryFromReader);
      msg.setTargetUserFollow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Follower.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Follower.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Follower} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Follower.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetUserItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getLastFollowedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getTargetUserFollow();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.jp.singcolor.UserFollow.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.Follower.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Follower} returns this
 */
proto.jp.singcolor.Follower.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UserItem target_user_item = 2;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.Follower.prototype.getTargetUserItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 2));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.Follower} returns this
*/
proto.jp.singcolor.Follower.prototype.setTargetUserItem = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Follower} returns this
 */
proto.jp.singcolor.Follower.prototype.clearTargetUserItem = function() {
  return this.setTargetUserItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Follower.prototype.hasTargetUserItem = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 last_followed_at = 3;
 * @return {number}
 */
proto.jp.singcolor.Follower.prototype.getLastFollowedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Follower} returns this
 */
proto.jp.singcolor.Follower.prototype.setLastFollowedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.jp.singcolor.Follower.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Follower} returns this
 */
proto.jp.singcolor.Follower.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.jp.singcolor.Follower.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Follower} returns this
 */
proto.jp.singcolor.Follower.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional UserFollow target_user_follow = 6;
 * @return {?proto.jp.singcolor.UserFollow}
 */
proto.jp.singcolor.Follower.prototype.getTargetUserFollow = function() {
  return /** @type{?proto.jp.singcolor.UserFollow} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserFollow, 6));
};


/**
 * @param {?proto.jp.singcolor.UserFollow|undefined} value
 * @return {!proto.jp.singcolor.Follower} returns this
*/
proto.jp.singcolor.Follower.prototype.setTargetUserFollow = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Follower} returns this
 */
proto.jp.singcolor.Follower.prototype.clearTargetUserFollow = function() {
  return this.setTargetUserFollow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Follower.prototype.hasTargetUserFollow = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Blocking.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Blocking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Blocking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Blocking.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    targetUserItem: (f = msg.getTargetUserItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    createdAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    userBlock: (f = msg.getUserBlock()) && proto.jp.singcolor.UserBlock.toObject(includeInstance, f),
    executorUser: (f = msg.getExecutorUser()) && proto.jp.singcolor.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Blocking}
 */
proto.jp.singcolor.Blocking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Blocking;
  return proto.jp.singcolor.Blocking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Blocking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Blocking}
 */
proto.jp.singcolor.Blocking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setTargetUserItem(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 5:
      var value = new proto.jp.singcolor.UserBlock;
      reader.readMessage(value,proto.jp.singcolor.UserBlock.deserializeBinaryFromReader);
      msg.setUserBlock(value);
      break;
    case 6:
      var value = new proto.jp.singcolor.User;
      reader.readMessage(value,proto.jp.singcolor.User.deserializeBinaryFromReader);
      msg.setExecutorUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Blocking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Blocking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Blocking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Blocking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetUserItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUserBlock();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.jp.singcolor.UserBlock.serializeBinaryToWriter
    );
  }
  f = message.getExecutorUser();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.jp.singcolor.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.Blocking.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Blocking} returns this
 */
proto.jp.singcolor.Blocking.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UserItem target_user_item = 2;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.Blocking.prototype.getTargetUserItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 2));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.Blocking} returns this
*/
proto.jp.singcolor.Blocking.prototype.setTargetUserItem = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Blocking} returns this
 */
proto.jp.singcolor.Blocking.prototype.clearTargetUserItem = function() {
  return this.setTargetUserItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Blocking.prototype.hasTargetUserItem = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 created_at = 3;
 * @return {number}
 */
proto.jp.singcolor.Blocking.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Blocking} returns this
 */
proto.jp.singcolor.Blocking.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 updated_at = 4;
 * @return {number}
 */
proto.jp.singcolor.Blocking.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Blocking} returns this
 */
proto.jp.singcolor.Blocking.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional UserBlock user_block = 5;
 * @return {?proto.jp.singcolor.UserBlock}
 */
proto.jp.singcolor.Blocking.prototype.getUserBlock = function() {
  return /** @type{?proto.jp.singcolor.UserBlock} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserBlock, 5));
};


/**
 * @param {?proto.jp.singcolor.UserBlock|undefined} value
 * @return {!proto.jp.singcolor.Blocking} returns this
*/
proto.jp.singcolor.Blocking.prototype.setUserBlock = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Blocking} returns this
 */
proto.jp.singcolor.Blocking.prototype.clearUserBlock = function() {
  return this.setUserBlock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Blocking.prototype.hasUserBlock = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional User executor_user = 6;
 * @return {?proto.jp.singcolor.User}
 */
proto.jp.singcolor.Blocking.prototype.getExecutorUser = function() {
  return /** @type{?proto.jp.singcolor.User} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.User, 6));
};


/**
 * @param {?proto.jp.singcolor.User|undefined} value
 * @return {!proto.jp.singcolor.Blocking} returns this
*/
proto.jp.singcolor.Blocking.prototype.setExecutorUser = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Blocking} returns this
 */
proto.jp.singcolor.Blocking.prototype.clearExecutorUser = function() {
  return this.setExecutorUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Blocking.prototype.hasExecutorUser = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.UserBanHistory.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserBanHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserBanHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserBanHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserBanHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    banHistoryList: jspb.Message.toObjectList(msg.getBanHistoryList(),
    proto.jp.singcolor.Ban.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserBanHistory}
 */
proto.jp.singcolor.UserBanHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserBanHistory;
  return proto.jp.singcolor.UserBanHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserBanHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserBanHistory}
 */
proto.jp.singcolor.UserBanHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.Ban;
      reader.readMessage(value,proto.jp.singcolor.Ban.deserializeBinaryFromReader);
      msg.addBanHistory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserBanHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserBanHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserBanHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserBanHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBanHistoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.jp.singcolor.Ban.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserBanHistory.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserBanHistory} returns this
 */
proto.jp.singcolor.UserBanHistory.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Ban ban_history = 2;
 * @return {!Array<!proto.jp.singcolor.Ban>}
 */
proto.jp.singcolor.UserBanHistory.prototype.getBanHistoryList = function() {
  return /** @type{!Array<!proto.jp.singcolor.Ban>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.jp.singcolor.Ban, 2));
};


/**
 * @param {!Array<!proto.jp.singcolor.Ban>} value
 * @return {!proto.jp.singcolor.UserBanHistory} returns this
*/
proto.jp.singcolor.UserBanHistory.prototype.setBanHistoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.jp.singcolor.Ban=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.Ban}
 */
proto.jp.singcolor.UserBanHistory.prototype.addBanHistory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.jp.singcolor.Ban, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.UserBanHistory} returns this
 */
proto.jp.singcolor.UserBanHistory.prototype.clearBanHistoryList = function() {
  return this.setBanHistoryList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Ban.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Ban.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Ban} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Ban.toObject = function(includeInstance, msg) {
  var f, obj = {
    violationCategory: (f = msg.getViolationCategory()) && master_violation_entity_pb.ViolationCategory.toObject(includeInstance, f),
    violationTarget: (f = msg.getViolationTarget()) && master_violation_entity_pb.ViolationTarget.toObject(includeInstance, f),
    banLevel: (f = msg.getBanLevel()) && master_violation_entity_pb.BanLevel.toObject(includeInstance, f),
    releaseAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isBanRevocable: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Ban}
 */
proto.jp.singcolor.Ban.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Ban;
  return proto.jp.singcolor.Ban.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Ban} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Ban}
 */
proto.jp.singcolor.Ban.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new master_violation_entity_pb.ViolationCategory;
      reader.readMessage(value,master_violation_entity_pb.ViolationCategory.deserializeBinaryFromReader);
      msg.setViolationCategory(value);
      break;
    case 2:
      var value = new master_violation_entity_pb.ViolationTarget;
      reader.readMessage(value,master_violation_entity_pb.ViolationTarget.deserializeBinaryFromReader);
      msg.setViolationTarget(value);
      break;
    case 3:
      var value = new master_violation_entity_pb.BanLevel;
      reader.readMessage(value,master_violation_entity_pb.BanLevel.deserializeBinaryFromReader);
      msg.setBanLevel(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReleaseAt(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBanRevocable(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Ban.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Ban.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Ban} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Ban.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViolationCategory();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      master_violation_entity_pb.ViolationCategory.serializeBinaryToWriter
    );
  }
  f = message.getViolationTarget();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      master_violation_entity_pb.ViolationTarget.serializeBinaryToWriter
    );
  }
  f = message.getBanLevel();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      master_violation_entity_pb.BanLevel.serializeBinaryToWriter
    );
  }
  f = message.getReleaseAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getIsBanRevocable();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional master.ViolationCategory violation_category = 1;
 * @return {?proto.jp.singcolor.master.ViolationCategory}
 */
proto.jp.singcolor.Ban.prototype.getViolationCategory = function() {
  return /** @type{?proto.jp.singcolor.master.ViolationCategory} */ (
    jspb.Message.getWrapperField(this, master_violation_entity_pb.ViolationCategory, 1));
};


/**
 * @param {?proto.jp.singcolor.master.ViolationCategory|undefined} value
 * @return {!proto.jp.singcolor.Ban} returns this
*/
proto.jp.singcolor.Ban.prototype.setViolationCategory = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Ban} returns this
 */
proto.jp.singcolor.Ban.prototype.clearViolationCategory = function() {
  return this.setViolationCategory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Ban.prototype.hasViolationCategory = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional master.ViolationTarget violation_target = 2;
 * @return {?proto.jp.singcolor.master.ViolationTarget}
 */
proto.jp.singcolor.Ban.prototype.getViolationTarget = function() {
  return /** @type{?proto.jp.singcolor.master.ViolationTarget} */ (
    jspb.Message.getWrapperField(this, master_violation_entity_pb.ViolationTarget, 2));
};


/**
 * @param {?proto.jp.singcolor.master.ViolationTarget|undefined} value
 * @return {!proto.jp.singcolor.Ban} returns this
*/
proto.jp.singcolor.Ban.prototype.setViolationTarget = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Ban} returns this
 */
proto.jp.singcolor.Ban.prototype.clearViolationTarget = function() {
  return this.setViolationTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Ban.prototype.hasViolationTarget = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional master.BanLevel ban_level = 3;
 * @return {?proto.jp.singcolor.master.BanLevel}
 */
proto.jp.singcolor.Ban.prototype.getBanLevel = function() {
  return /** @type{?proto.jp.singcolor.master.BanLevel} */ (
    jspb.Message.getWrapperField(this, master_violation_entity_pb.BanLevel, 3));
};


/**
 * @param {?proto.jp.singcolor.master.BanLevel|undefined} value
 * @return {!proto.jp.singcolor.Ban} returns this
*/
proto.jp.singcolor.Ban.prototype.setBanLevel = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Ban} returns this
 */
proto.jp.singcolor.Ban.prototype.clearBanLevel = function() {
  return this.setBanLevel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Ban.prototype.hasBanLevel = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 release_at = 4;
 * @return {number}
 */
proto.jp.singcolor.Ban.prototype.getReleaseAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Ban} returns this
 */
proto.jp.singcolor.Ban.prototype.setReleaseAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_ban_revocable = 5;
 * @return {boolean}
 */
proto.jp.singcolor.Ban.prototype.getIsBanRevocable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.Ban} returns this
 */
proto.jp.singcolor.Ban.prototype.setIsBanRevocable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.jp.singcolor.Ban.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Ban} returns this
 */
proto.jp.singcolor.Ban.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 updated_at = 7;
 * @return {number}
 */
proto.jp.singcolor.Ban.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Ban} returns this
 */
proto.jp.singcolor.Ban.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.UserProfileScreening.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserProfileScreening.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserProfileScreening.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserProfileScreening} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserProfileScreening.toObject = function(includeInstance, msg) {
  var f, obj = {
    userProfile: (f = msg.getUserProfile()) && proto.jp.singcolor.UserProfile.toObject(includeInstance, f),
    screeningTargetsList: jspb.Message.toObjectList(msg.getScreeningTargetsList(),
    master_violation_entity_pb.ViolationTarget.toObject, includeInstance),
    liveBackgroundImageUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserProfileScreening}
 */
proto.jp.singcolor.UserProfileScreening.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserProfileScreening;
  return proto.jp.singcolor.UserProfileScreening.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserProfileScreening} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserProfileScreening}
 */
proto.jp.singcolor.UserProfileScreening.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.jp.singcolor.UserProfile;
      reader.readMessage(value,proto.jp.singcolor.UserProfile.deserializeBinaryFromReader);
      msg.setUserProfile(value);
      break;
    case 2:
      var value = new master_violation_entity_pb.ViolationTarget;
      reader.readMessage(value,master_violation_entity_pb.ViolationTarget.deserializeBinaryFromReader);
      msg.addScreeningTargets(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiveBackgroundImageUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserProfileScreening.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserProfileScreening.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserProfileScreening} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserProfileScreening.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserProfile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.jp.singcolor.UserProfile.serializeBinaryToWriter
    );
  }
  f = message.getScreeningTargetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      master_violation_entity_pb.ViolationTarget.serializeBinaryToWriter
    );
  }
  f = message.getLiveBackgroundImageUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional UserProfile user_profile = 1;
 * @return {?proto.jp.singcolor.UserProfile}
 */
proto.jp.singcolor.UserProfileScreening.prototype.getUserProfile = function() {
  return /** @type{?proto.jp.singcolor.UserProfile} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserProfile, 1));
};


/**
 * @param {?proto.jp.singcolor.UserProfile|undefined} value
 * @return {!proto.jp.singcolor.UserProfileScreening} returns this
*/
proto.jp.singcolor.UserProfileScreening.prototype.setUserProfile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserProfileScreening} returns this
 */
proto.jp.singcolor.UserProfileScreening.prototype.clearUserProfile = function() {
  return this.setUserProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserProfileScreening.prototype.hasUserProfile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated master.ViolationTarget screening_targets = 2;
 * @return {!Array<!proto.jp.singcolor.master.ViolationTarget>}
 */
proto.jp.singcolor.UserProfileScreening.prototype.getScreeningTargetsList = function() {
  return /** @type{!Array<!proto.jp.singcolor.master.ViolationTarget>} */ (
    jspb.Message.getRepeatedWrapperField(this, master_violation_entity_pb.ViolationTarget, 2));
};


/**
 * @param {!Array<!proto.jp.singcolor.master.ViolationTarget>} value
 * @return {!proto.jp.singcolor.UserProfileScreening} returns this
*/
proto.jp.singcolor.UserProfileScreening.prototype.setScreeningTargetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.jp.singcolor.master.ViolationTarget=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.master.ViolationTarget}
 */
proto.jp.singcolor.UserProfileScreening.prototype.addScreeningTargets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.jp.singcolor.master.ViolationTarget, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.UserProfileScreening} returns this
 */
proto.jp.singcolor.UserProfileScreening.prototype.clearScreeningTargetsList = function() {
  return this.setScreeningTargetsList([]);
};


/**
 * optional string live_background_image_url = 3;
 * @return {string}
 */
proto.jp.singcolor.UserProfileScreening.prototype.getLiveBackgroundImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserProfileScreening} returns this
 */
proto.jp.singcolor.UserProfileScreening.prototype.setLiveBackgroundImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserItemWithFollow.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserItemWithFollow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserItemWithFollow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserItemWithFollow.toObject = function(includeInstance, msg) {
  var f, obj = {
    userItem: (f = msg.getUserItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    userFollow: (f = msg.getUserFollow()) && proto.jp.singcolor.UserFollow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserItemWithFollow}
 */
proto.jp.singcolor.UserItemWithFollow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserItemWithFollow;
  return proto.jp.singcolor.UserItemWithFollow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserItemWithFollow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserItemWithFollow}
 */
proto.jp.singcolor.UserItemWithFollow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setUserItem(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.UserFollow;
      reader.readMessage(value,proto.jp.singcolor.UserFollow.deserializeBinaryFromReader);
      msg.setUserFollow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserItemWithFollow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserItemWithFollow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserItemWithFollow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserItemWithFollow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getUserFollow();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.UserFollow.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserItem user_item = 1;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.UserItemWithFollow.prototype.getUserItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 1));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.UserItemWithFollow} returns this
*/
proto.jp.singcolor.UserItemWithFollow.prototype.setUserItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserItemWithFollow} returns this
 */
proto.jp.singcolor.UserItemWithFollow.prototype.clearUserItem = function() {
  return this.setUserItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserItemWithFollow.prototype.hasUserItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserFollow user_follow = 2;
 * @return {?proto.jp.singcolor.UserFollow}
 */
proto.jp.singcolor.UserItemWithFollow.prototype.getUserFollow = function() {
  return /** @type{?proto.jp.singcolor.UserFollow} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserFollow, 2));
};


/**
 * @param {?proto.jp.singcolor.UserFollow|undefined} value
 * @return {!proto.jp.singcolor.UserItemWithFollow} returns this
*/
proto.jp.singcolor.UserItemWithFollow.prototype.setUserFollow = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserItemWithFollow} returns this
 */
proto.jp.singcolor.UserItemWithFollow.prototype.clearUserFollow = function() {
  return this.setUserFollow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserItemWithFollow.prototype.hasUserFollow = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.SearchUser.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.SearchUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.SearchUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.SearchUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    userItem: (f = msg.getUserItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    userFollow: (f = msg.getUserFollow()) && proto.jp.singcolor.UserFollow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.SearchUser}
 */
proto.jp.singcolor.SearchUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.SearchUser;
  return proto.jp.singcolor.SearchUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.SearchUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.SearchUser}
 */
proto.jp.singcolor.SearchUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setUserItem(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.UserFollow;
      reader.readMessage(value,proto.jp.singcolor.UserFollow.deserializeBinaryFromReader);
      msg.setUserFollow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.SearchUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.SearchUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.SearchUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.SearchUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getUserFollow();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.UserFollow.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserItem user_item = 1;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.SearchUser.prototype.getUserItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 1));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.SearchUser} returns this
*/
proto.jp.singcolor.SearchUser.prototype.setUserItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.SearchUser} returns this
 */
proto.jp.singcolor.SearchUser.prototype.clearUserItem = function() {
  return this.setUserItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.SearchUser.prototype.hasUserItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserFollow user_follow = 2;
 * @return {?proto.jp.singcolor.UserFollow}
 */
proto.jp.singcolor.SearchUser.prototype.getUserFollow = function() {
  return /** @type{?proto.jp.singcolor.UserFollow} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserFollow, 2));
};


/**
 * @param {?proto.jp.singcolor.UserFollow|undefined} value
 * @return {!proto.jp.singcolor.SearchUser} returns this
*/
proto.jp.singcolor.SearchUser.prototype.setUserFollow = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.SearchUser} returns this
 */
proto.jp.singcolor.SearchUser.prototype.clearUserFollow = function() {
  return this.setUserFollow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.SearchUser.prototype.hasUserFollow = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserItemWithFavePoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserItemWithFavePoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserItemWithFavePoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    userItem: (f = msg.getUserItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    termlyFavePoints: jspb.Message.getFieldWithDefault(msg, 2, 0),
    monthlyFavePoints: jspb.Message.getFieldWithDefault(msg, 3, 0),
    viewingAreaInfo: (f = msg.getViewingAreaInfo()) && proto.jp.singcolor.ViewingAreaInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserItemWithFavePoint}
 */
proto.jp.singcolor.UserItemWithFavePoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserItemWithFavePoint;
  return proto.jp.singcolor.UserItemWithFavePoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserItemWithFavePoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserItemWithFavePoint}
 */
proto.jp.singcolor.UserItemWithFavePoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setUserItem(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTermlyFavePoints(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonthlyFavePoints(value);
      break;
    case 4:
      var value = new proto.jp.singcolor.ViewingAreaInfo;
      reader.readMessage(value,proto.jp.singcolor.ViewingAreaInfo.deserializeBinaryFromReader);
      msg.setViewingAreaInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserItemWithFavePoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserItemWithFavePoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserItemWithFavePoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getTermlyFavePoints();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMonthlyFavePoints();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getViewingAreaInfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.jp.singcolor.ViewingAreaInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserItem user_item = 1;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.getUserItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 1));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.UserItemWithFavePoint} returns this
*/
proto.jp.singcolor.UserItemWithFavePoint.prototype.setUserItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserItemWithFavePoint} returns this
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.clearUserItem = function() {
  return this.setUserItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.hasUserItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 termly_fave_points = 2;
 * @return {number}
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.getTermlyFavePoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserItemWithFavePoint} returns this
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.setTermlyFavePoints = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 monthly_fave_points = 3;
 * @return {number}
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.getMonthlyFavePoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserItemWithFavePoint} returns this
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.setMonthlyFavePoints = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ViewingAreaInfo viewing_area_info = 4;
 * @return {?proto.jp.singcolor.ViewingAreaInfo}
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.getViewingAreaInfo = function() {
  return /** @type{?proto.jp.singcolor.ViewingAreaInfo} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.ViewingAreaInfo, 4));
};


/**
 * @param {?proto.jp.singcolor.ViewingAreaInfo|undefined} value
 * @return {!proto.jp.singcolor.UserItemWithFavePoint} returns this
*/
proto.jp.singcolor.UserItemWithFavePoint.prototype.setViewingAreaInfo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserItemWithFavePoint} returns this
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.clearViewingAreaInfo = function() {
  return this.setViewingAreaInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserItemWithFavePoint.prototype.hasViewingAreaInfo = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.RankingLiver.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.RankingLiver.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.RankingLiver} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.RankingLiver.toObject = function(includeInstance, msg) {
  var f, obj = {
    userItem: (f = msg.getUserItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    userFollow: (f = msg.getUserFollow()) && proto.jp.singcolor.UserFollow.toObject(includeInstance, f),
    rank: jspb.Message.getFieldWithDefault(msg, 3, 0),
    liveScore: jspb.Message.getFieldWithDefault(msg, 4, 0),
    hidden: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.RankingLiver}
 */
proto.jp.singcolor.RankingLiver.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.RankingLiver;
  return proto.jp.singcolor.RankingLiver.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.RankingLiver} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.RankingLiver}
 */
proto.jp.singcolor.RankingLiver.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setUserItem(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.UserFollow;
      reader.readMessage(value,proto.jp.singcolor.UserFollow.deserializeBinaryFromReader);
      msg.setUserFollow(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRank(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLiveScore(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.RankingLiver.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.RankingLiver.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.RankingLiver} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.RankingLiver.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getUserFollow();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.UserFollow.serializeBinaryToWriter
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getLiveScore();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional UserItem user_item = 1;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.RankingLiver.prototype.getUserItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 1));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.RankingLiver} returns this
*/
proto.jp.singcolor.RankingLiver.prototype.setUserItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.RankingLiver} returns this
 */
proto.jp.singcolor.RankingLiver.prototype.clearUserItem = function() {
  return this.setUserItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.RankingLiver.prototype.hasUserItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserFollow user_follow = 2;
 * @return {?proto.jp.singcolor.UserFollow}
 */
proto.jp.singcolor.RankingLiver.prototype.getUserFollow = function() {
  return /** @type{?proto.jp.singcolor.UserFollow} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserFollow, 2));
};


/**
 * @param {?proto.jp.singcolor.UserFollow|undefined} value
 * @return {!proto.jp.singcolor.RankingLiver} returns this
*/
proto.jp.singcolor.RankingLiver.prototype.setUserFollow = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.RankingLiver} returns this
 */
proto.jp.singcolor.RankingLiver.prototype.clearUserFollow = function() {
  return this.setUserFollow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.RankingLiver.prototype.hasUserFollow = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 rank = 3;
 * @return {number}
 */
proto.jp.singcolor.RankingLiver.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.RankingLiver} returns this
 */
proto.jp.singcolor.RankingLiver.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 live_score = 4;
 * @return {number}
 */
proto.jp.singcolor.RankingLiver.prototype.getLiveScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.RankingLiver} returns this
 */
proto.jp.singcolor.RankingLiver.prototype.setLiveScore = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool hidden = 5;
 * @return {boolean}
 */
proto.jp.singcolor.RankingLiver.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.RankingLiver} returns this
 */
proto.jp.singcolor.RankingLiver.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.RankingTerm.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.RankingTerm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.RankingTerm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.RankingTerm.toObject = function(includeInstance, msg) {
  var f, obj = {
    rankingTermId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    enableTimelineFilter: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    enableGenderFilter: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    enableWorldFilter: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.RankingTerm}
 */
proto.jp.singcolor.RankingTerm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.RankingTerm;
  return proto.jp.singcolor.RankingTerm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.RankingTerm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.RankingTerm}
 */
proto.jp.singcolor.RankingTerm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRankingTermId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableTimelineFilter(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableGenderFilter(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableWorldFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.RankingTerm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.RankingTerm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.RankingTerm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.RankingTerm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRankingTermId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEnableTimelineFilter();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getEnableGenderFilter();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getEnableWorldFilter();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string ranking_term_id = 1;
 * @return {string}
 */
proto.jp.singcolor.RankingTerm.prototype.getRankingTermId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.RankingTerm} returns this
 */
proto.jp.singcolor.RankingTerm.prototype.setRankingTermId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.jp.singcolor.RankingTerm.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.RankingTerm} returns this
 */
proto.jp.singcolor.RankingTerm.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool enable_timeline_filter = 3;
 * @return {boolean}
 */
proto.jp.singcolor.RankingTerm.prototype.getEnableTimelineFilter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.RankingTerm} returns this
 */
proto.jp.singcolor.RankingTerm.prototype.setEnableTimelineFilter = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool enable_gender_filter = 4;
 * @return {boolean}
 */
proto.jp.singcolor.RankingTerm.prototype.getEnableGenderFilter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.RankingTerm} returns this
 */
proto.jp.singcolor.RankingTerm.prototype.setEnableGenderFilter = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool enable_world_filter = 5;
 * @return {boolean}
 */
proto.jp.singcolor.RankingTerm.prototype.getEnableWorldFilter = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.RankingTerm} returns this
 */
proto.jp.singcolor.RankingTerm.prototype.setEnableWorldFilter = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UnreadNotificationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UnreadNotificationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UnreadNotificationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemTabLastReadAt: jspb.Message.getFieldWithDefault(msg, 1, 0),
    systemTabUnreadCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    operatorTabLastReadAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    operatorTabUnreadCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UnreadNotificationInfo}
 */
proto.jp.singcolor.UnreadNotificationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UnreadNotificationInfo;
  return proto.jp.singcolor.UnreadNotificationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UnreadNotificationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UnreadNotificationInfo}
 */
proto.jp.singcolor.UnreadNotificationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSystemTabLastReadAt(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSystemTabUnreadCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperatorTabLastReadAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperatorTabUnreadCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UnreadNotificationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UnreadNotificationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UnreadNotificationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemTabLastReadAt();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSystemTabUnreadCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOperatorTabLastReadAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOperatorTabUnreadCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 system_tab_last_read_at = 1;
 * @return {number}
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.getSystemTabLastReadAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UnreadNotificationInfo} returns this
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.setSystemTabLastReadAt = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 system_tab_unread_count = 2;
 * @return {number}
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.getSystemTabUnreadCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UnreadNotificationInfo} returns this
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.setSystemTabUnreadCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 operator_tab_last_read_at = 3;
 * @return {number}
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.getOperatorTabLastReadAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UnreadNotificationInfo} returns this
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.setOperatorTabLastReadAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 operator_tab_unread_count = 4;
 * @return {number}
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.getOperatorTabUnreadCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UnreadNotificationInfo} returns this
 */
proto.jp.singcolor.UnreadNotificationInfo.prototype.setOperatorTabUnreadCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.AcquireDiamondCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.AcquireDiamondCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.AcquireDiamondCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AcquireDiamondCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    isSatisfied: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.AcquireDiamondCondition}
 */
proto.jp.singcolor.AcquireDiamondCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.AcquireDiamondCondition;
  return proto.jp.singcolor.AcquireDiamondCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.AcquireDiamondCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.AcquireDiamondCondition}
 */
proto.jp.singcolor.AcquireDiamondCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSatisfied(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.AcquireDiamondCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.AcquireDiamondCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.AcquireDiamondCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AcquireDiamondCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsSatisfied();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional bool is_satisfied = 1;
 * @return {boolean}
 */
proto.jp.singcolor.AcquireDiamondCondition.prototype.getIsSatisfied = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.AcquireDiamondCondition} returns this
 */
proto.jp.singcolor.AcquireDiamondCondition.prototype.setIsSatisfied = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.jp.singcolor.AcquireDiamondCondition.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AcquireDiamondCondition} returns this
 */
proto.jp.singcolor.AcquireDiamondCondition.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.MonthlyStatisticsPageKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.MonthlyStatisticsPageKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    year: jspb.Message.getFieldWithDefault(msg, 1, 0),
    month: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.MonthlyStatisticsPageKey}
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.MonthlyStatisticsPageKey;
  return proto.jp.singcolor.MonthlyStatisticsPageKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.MonthlyStatisticsPageKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.MonthlyStatisticsPageKey}
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setYear(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.MonthlyStatisticsPageKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.MonthlyStatisticsPageKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getYear();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getMonth();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 year = 1;
 * @return {number}
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.MonthlyStatisticsPageKey} returns this
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.prototype.setYear = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 month = 2;
 * @return {number}
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.prototype.getMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.MonthlyStatisticsPageKey} returns this
 */
proto.jp.singcolor.MonthlyStatisticsPageKey.prototype.setMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.AcquiredDiamondDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.AcquiredDiamondDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AcquiredDiamondDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalAmount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    chatDiamondAmount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    usedChatDiamondAcquisitionRight: jspb.Message.getFieldWithDefault(msg, 3, ""),
    chatDiamondUnitPrice: jspb.Message.getFieldWithDefault(msg, 4, 0),
    singDiamondAmount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    singDiamondUnitPrice: jspb.Message.getFieldWithDefault(msg, 6, 0),
    singDiamondStartDashBonus: jspb.Message.getFieldWithDefault(msg, 12, 0),
    singDiamondRate: jspb.Message.getFieldWithDefault(msg, 7, ""),
    usedSingDiamondAcquisitionRight: jspb.Message.getFieldWithDefault(msg, 8, ""),
    distributedAccumulationDiamondFundAmount: jspb.Message.getFieldWithDefault(msg, 9, 0),
    supportCommissionAmount: jspb.Message.getFieldWithDefault(msg, 10, 0),
    membershipDiamondAmount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    leagueId: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail}
 */
proto.jp.singcolor.AcquiredDiamondDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.AcquiredDiamondDetail;
  return proto.jp.singcolor.AcquiredDiamondDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.AcquiredDiamondDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail}
 */
proto.jp.singcolor.AcquiredDiamondDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalAmount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChatDiamondAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsedChatDiamondAcquisitionRight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChatDiamondUnitPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSingDiamondAmount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSingDiamondUnitPrice(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSingDiamondStartDashBonus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSingDiamondRate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsedSingDiamondAcquisitionRight(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDistributedAccumulationDiamondFundAmount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSupportCommissionAmount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMembershipDiamondAmount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeagueId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.AcquiredDiamondDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.AcquiredDiamondDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AcquiredDiamondDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getChatDiamondAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUsedChatDiamondAcquisitionRight();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChatDiamondUnitPrice();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSingDiamondAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSingDiamondUnitPrice();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getSingDiamondStartDashBonus();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getSingDiamondRate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUsedSingDiamondAcquisitionRight();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDistributedAccumulationDiamondFundAmount();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getSupportCommissionAmount();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getMembershipDiamondAmount();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getLeagueId();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional int64 total_amount = 1;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getTotalAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setTotalAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 chat_diamond_amount = 2;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getChatDiamondAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setChatDiamondAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string used_chat_diamond_acquisition_right = 3;
 * @return {string}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getUsedChatDiamondAcquisitionRight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setUsedChatDiamondAcquisitionRight = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 chat_diamond_unit_price = 4;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getChatDiamondUnitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setChatDiamondUnitPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 sing_diamond_amount = 5;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getSingDiamondAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setSingDiamondAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 sing_diamond_unit_price = 6;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getSingDiamondUnitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setSingDiamondUnitPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 sing_diamond_start_dash_bonus = 12;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getSingDiamondStartDashBonus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setSingDiamondStartDashBonus = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string sing_diamond_rate = 7;
 * @return {string}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getSingDiamondRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setSingDiamondRate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string used_sing_diamond_acquisition_right = 8;
 * @return {string}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getUsedSingDiamondAcquisitionRight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setUsedSingDiamondAcquisitionRight = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 distributed_accumulation_diamond_fund_amount = 9;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getDistributedAccumulationDiamondFundAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setDistributedAccumulationDiamondFundAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 support_commission_amount = 10;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getSupportCommissionAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setSupportCommissionAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 membership_diamond_amount = 13;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getMembershipDiamondAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setMembershipDiamondAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 league_id = 11;
 * @return {number}
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.getLeagueId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AcquiredDiamondDetail} returns this
 */
proto.jp.singcolor.AcquiredDiamondDetail.prototype.setLeagueId = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.StatisticsRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.StatisticsRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.StatisticsRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.StatisticsRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    termStartTime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    termLabel: jspb.Message.getFieldWithDefault(msg, 13, ""),
    closingTime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    closed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    acquiredPoint: jspb.Message.getFieldWithDefault(msg, 4, 0),
    fromLeagueId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    toLeagueId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    exceedingExp: jspb.Message.getFieldWithDefault(msg, 15, 0),
    diamondAmountDetail: (f = msg.getDiamondAmountDetail()) && proto.jp.singcolor.AcquiredDiamondDetail.toObject(includeInstance, f),
    accumulatedDiamond: jspb.Message.getFieldWithDefault(msg, 12, 0),
    liveDuration: jspb.Message.getFieldWithDefault(msg, 8, 0),
    songCount: jspb.Message.getFieldWithDefault(msg, 9, 0),
    songFaveCount: jspb.Message.getFieldWithDefault(msg, 10, 0),
    songFaveTotalCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    favePoints: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.StatisticsRecord}
 */
proto.jp.singcolor.StatisticsRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.StatisticsRecord;
  return proto.jp.singcolor.StatisticsRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.StatisticsRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.StatisticsRecord}
 */
proto.jp.singcolor.StatisticsRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTermStartTime(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTermLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClosingTime(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClosed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAcquiredPoint(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFromLeagueId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setToLeagueId(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExceedingExp(value);
      break;
    case 7:
      var value = new proto.jp.singcolor.AcquiredDiamondDetail;
      reader.readMessage(value,proto.jp.singcolor.AcquiredDiamondDetail.deserializeBinaryFromReader);
      msg.setDiamondAmountDetail(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccumulatedDiamond(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLiveDuration(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSongCount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSongFaveCount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSongFaveTotalCount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFavePoints(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.StatisticsRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.StatisticsRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.StatisticsRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.StatisticsRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTermStartTime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTermLabel();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getClosingTime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getClosed();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAcquiredPoint();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getFromLeagueId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getToLeagueId();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExceedingExp();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getDiamondAmountDetail();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.jp.singcolor.AcquiredDiamondDetail.serializeBinaryToWriter
    );
  }
  f = message.getAccumulatedDiamond();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getLiveDuration();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getSongCount();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getSongFaveCount();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getSongFaveTotalCount();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getFavePoints();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional int64 term_start_time = 1;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getTermStartTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setTermStartTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string term_label = 13;
 * @return {string}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getTermLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setTermLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 closing_time = 2;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getClosingTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setClosingTime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool closed = 3;
 * @return {boolean}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getClosed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setClosed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional int64 acquired_point = 4;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getAcquiredPoint = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setAcquiredPoint = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 from_league_id = 5;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getFromLeagueId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setFromLeagueId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 to_league_id = 6;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getToLeagueId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setToLeagueId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 exceeding_exp = 15;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getExceedingExp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setExceedingExp = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional AcquiredDiamondDetail diamond_amount_detail = 7;
 * @return {?proto.jp.singcolor.AcquiredDiamondDetail}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getDiamondAmountDetail = function() {
  return /** @type{?proto.jp.singcolor.AcquiredDiamondDetail} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.AcquiredDiamondDetail, 7));
};


/**
 * @param {?proto.jp.singcolor.AcquiredDiamondDetail|undefined} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
*/
proto.jp.singcolor.StatisticsRecord.prototype.setDiamondAmountDetail = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.clearDiamondAmountDetail = function() {
  return this.setDiamondAmountDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.StatisticsRecord.prototype.hasDiamondAmountDetail = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 accumulated_diamond = 12;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getAccumulatedDiamond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setAccumulatedDiamond = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 live_duration = 8;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getLiveDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setLiveDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 song_count = 9;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getSongCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setSongCount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 song_fave_count = 10;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getSongFaveCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setSongFaveCount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 song_fave_total_count = 14;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getSongFaveTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setSongFaveTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 fave_points = 11;
 * @return {number}
 */
proto.jp.singcolor.StatisticsRecord.prototype.getFavePoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.StatisticsRecord} returns this
 */
proto.jp.singcolor.StatisticsRecord.prototype.setFavePoints = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.DayOfLiverTerm.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.DayOfLiverTerm.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.DayOfLiverTerm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.DayOfLiverTerm.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.DayOfLiverTerm}
 */
proto.jp.singcolor.DayOfLiverTerm.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.DayOfLiverTerm;
  return proto.jp.singcolor.DayOfLiverTerm.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.DayOfLiverTerm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.DayOfLiverTerm}
 */
proto.jp.singcolor.DayOfLiverTerm.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.DayOfLiverTerm.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.DayOfLiverTerm.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.DayOfLiverTerm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.DayOfLiverTerm.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.jp.singcolor.DayOfLiverTerm.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.DayOfLiverTerm} returns this
 */
proto.jp.singcolor.DayOfLiverTerm.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.jp.singcolor.DayOfLiverTerm.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.DayOfLiverTerm} returns this
 */
proto.jp.singcolor.DayOfLiverTerm.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.AvailableClosingTime.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.AvailableClosingTime.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.AvailableClosingTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.AvailableClosingTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AvailableClosingTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    listClosingTimeJstList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    dayOfLiverTerm: (f = msg.getDayOfLiverTerm()) && proto.jp.singcolor.DayOfLiverTerm.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.AvailableClosingTime}
 */
proto.jp.singcolor.AvailableClosingTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.AvailableClosingTime;
  return proto.jp.singcolor.AvailableClosingTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.AvailableClosingTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.AvailableClosingTime}
 */
proto.jp.singcolor.AvailableClosingTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setListClosingTimeJstList(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.DayOfLiverTerm;
      reader.readMessage(value,proto.jp.singcolor.DayOfLiverTerm.deserializeBinaryFromReader);
      msg.setDayOfLiverTerm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.AvailableClosingTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.AvailableClosingTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.AvailableClosingTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AvailableClosingTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListClosingTimeJstList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
  f = message.getDayOfLiverTerm();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.DayOfLiverTerm.serializeBinaryToWriter
    );
  }
};


/**
 * repeated int64 list_closing_time_jst = 1;
 * @return {!Array<number>}
 */
proto.jp.singcolor.AvailableClosingTime.prototype.getListClosingTimeJstList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.jp.singcolor.AvailableClosingTime} returns this
 */
proto.jp.singcolor.AvailableClosingTime.prototype.setListClosingTimeJstList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.AvailableClosingTime} returns this
 */
proto.jp.singcolor.AvailableClosingTime.prototype.addListClosingTimeJst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.AvailableClosingTime} returns this
 */
proto.jp.singcolor.AvailableClosingTime.prototype.clearListClosingTimeJstList = function() {
  return this.setListClosingTimeJstList([]);
};


/**
 * optional DayOfLiverTerm day_of_liver_term = 2;
 * @return {?proto.jp.singcolor.DayOfLiverTerm}
 */
proto.jp.singcolor.AvailableClosingTime.prototype.getDayOfLiverTerm = function() {
  return /** @type{?proto.jp.singcolor.DayOfLiverTerm} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.DayOfLiverTerm, 2));
};


/**
 * @param {?proto.jp.singcolor.DayOfLiverTerm|undefined} value
 * @return {!proto.jp.singcolor.AvailableClosingTime} returns this
*/
proto.jp.singcolor.AvailableClosingTime.prototype.setDayOfLiverTerm = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.AvailableClosingTime} returns this
 */
proto.jp.singcolor.AvailableClosingTime.prototype.clearDayOfLiverTerm = function() {
  return this.setDayOfLiverTerm(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.AvailableClosingTime.prototype.hasDayOfLiverTerm = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserLiveClosingTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserLiveClosingTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserLiveClosingTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    closingTimeJst: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nextClosingTimeJst: jspb.Message.getFieldWithDefault(msg, 2, 0),
    effectiveFrom: (f = msg.getEffectiveFrom()) && proto.jp.singcolor.DayOfLiverTerm.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserLiveClosingTime}
 */
proto.jp.singcolor.UserLiveClosingTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserLiveClosingTime;
  return proto.jp.singcolor.UserLiveClosingTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserLiveClosingTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserLiveClosingTime}
 */
proto.jp.singcolor.UserLiveClosingTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClosingTimeJst(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextClosingTimeJst(value);
      break;
    case 3:
      var value = new proto.jp.singcolor.DayOfLiverTerm;
      reader.readMessage(value,proto.jp.singcolor.DayOfLiverTerm.deserializeBinaryFromReader);
      msg.setEffectiveFrom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserLiveClosingTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserLiveClosingTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserLiveClosingTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClosingTimeJst();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNextClosingTimeJst();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getEffectiveFrom();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.jp.singcolor.DayOfLiverTerm.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 closing_time_jst = 1;
 * @return {number}
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.getClosingTimeJst = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserLiveClosingTime} returns this
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.setClosingTimeJst = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 next_closing_time_jst = 2;
 * @return {number}
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.getNextClosingTimeJst = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserLiveClosingTime} returns this
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.setNextClosingTimeJst = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional DayOfLiverTerm effective_from = 3;
 * @return {?proto.jp.singcolor.DayOfLiverTerm}
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.getEffectiveFrom = function() {
  return /** @type{?proto.jp.singcolor.DayOfLiverTerm} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.DayOfLiverTerm, 3));
};


/**
 * @param {?proto.jp.singcolor.DayOfLiverTerm|undefined} value
 * @return {!proto.jp.singcolor.UserLiveClosingTime} returns this
*/
proto.jp.singcolor.UserLiveClosingTime.prototype.setEffectiveFrom = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserLiveClosingTime} returns this
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.clearEffectiveFrom = function() {
  return this.setEffectiveFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserLiveClosingTime.prototype.hasEffectiveFrom = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.PearlCup.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.PearlCup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.PearlCup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCup.toObject = function(includeInstance, msg) {
  var f, obj = {
    pearlCupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    termLabel: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.PearlCup}
 */
proto.jp.singcolor.PearlCup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.PearlCup;
  return proto.jp.singcolor.PearlCup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.PearlCup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.PearlCup}
 */
proto.jp.singcolor.PearlCup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPearlCupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTermLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.PearlCup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.PearlCup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.PearlCup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPearlCupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTermLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string pearl_cup_id = 1;
 * @return {string}
 */
proto.jp.singcolor.PearlCup.prototype.getPearlCupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCup} returns this
 */
proto.jp.singcolor.PearlCup.prototype.setPearlCupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.jp.singcolor.PearlCup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCup} returns this
 */
proto.jp.singcolor.PearlCup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string term_label = 3;
 * @return {string}
 */
proto.jp.singcolor.PearlCup.prototype.getTermLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCup} returns this
 */
proto.jp.singcolor.PearlCup.prototype.setTermLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.PearlCupDivision.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.PearlCupDivision.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.PearlCupDivision} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupDivision.toObject = function(includeInstance, msg) {
  var f, obj = {
    pearlCupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pearlCupDivisionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isOverallDivision: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    startAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    endAt: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.PearlCupDivision}
 */
proto.jp.singcolor.PearlCupDivision.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.PearlCupDivision;
  return proto.jp.singcolor.PearlCupDivision.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.PearlCupDivision} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.PearlCupDivision}
 */
proto.jp.singcolor.PearlCupDivision.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPearlCupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPearlCupDivisionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOverallDivision(value);
      break;
    case 5:
      var value = /** @type {!proto.jp.singcolor.PearlCupDivisionHoldingStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.PearlCupDivision.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.PearlCupDivision.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.PearlCupDivision} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupDivision.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPearlCupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPearlCupDivisionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsOverallDivision();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStartAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getEndAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional string pearl_cup_id = 1;
 * @return {string}
 */
proto.jp.singcolor.PearlCupDivision.prototype.getPearlCupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupDivision} returns this
 */
proto.jp.singcolor.PearlCupDivision.prototype.setPearlCupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pearl_cup_division_id = 2;
 * @return {string}
 */
proto.jp.singcolor.PearlCupDivision.prototype.getPearlCupDivisionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupDivision} returns this
 */
proto.jp.singcolor.PearlCupDivision.prototype.setPearlCupDivisionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.jp.singcolor.PearlCupDivision.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupDivision} returns this
 */
proto.jp.singcolor.PearlCupDivision.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_overall_division = 4;
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupDivision.prototype.getIsOverallDivision = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.PearlCupDivision} returns this
 */
proto.jp.singcolor.PearlCupDivision.prototype.setIsOverallDivision = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional PearlCupDivisionHoldingStatus status = 5;
 * @return {!proto.jp.singcolor.PearlCupDivisionHoldingStatus}
 */
proto.jp.singcolor.PearlCupDivision.prototype.getStatus = function() {
  return /** @type {!proto.jp.singcolor.PearlCupDivisionHoldingStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.jp.singcolor.PearlCupDivisionHoldingStatus} value
 * @return {!proto.jp.singcolor.PearlCupDivision} returns this
 */
proto.jp.singcolor.PearlCupDivision.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 start_at = 6;
 * @return {number}
 */
proto.jp.singcolor.PearlCupDivision.prototype.getStartAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupDivision} returns this
 */
proto.jp.singcolor.PearlCupDivision.prototype.setStartAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 end_at = 7;
 * @return {number}
 */
proto.jp.singcolor.PearlCupDivision.prototype.getEndAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupDivision} returns this
 */
proto.jp.singcolor.PearlCupDivision.prototype.setEndAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.PearlCupDivisionWithPrize.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.PearlCupDivisionWithPrize} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.toObject = function(includeInstance, msg) {
  var f, obj = {
    division: (f = msg.getDivision()) && proto.jp.singcolor.PearlCupDivision.toObject(includeInstance, f),
    prize: (f = msg.getPrize()) && proto.jp.singcolor.PearlCupPrize.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.PearlCupDivisionWithPrize}
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.PearlCupDivisionWithPrize;
  return proto.jp.singcolor.PearlCupDivisionWithPrize.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.PearlCupDivisionWithPrize} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.PearlCupDivisionWithPrize}
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.jp.singcolor.PearlCupDivision;
      reader.readMessage(value,proto.jp.singcolor.PearlCupDivision.deserializeBinaryFromReader);
      msg.setDivision(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.PearlCupPrize;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.deserializeBinaryFromReader);
      msg.setPrize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.PearlCupDivisionWithPrize.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.PearlCupDivisionWithPrize} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDivision();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.jp.singcolor.PearlCupDivision.serializeBinaryToWriter
    );
  }
  f = message.getPrize();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.PearlCupPrize.serializeBinaryToWriter
    );
  }
};


/**
 * optional PearlCupDivision division = 1;
 * @return {?proto.jp.singcolor.PearlCupDivision}
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.getDivision = function() {
  return /** @type{?proto.jp.singcolor.PearlCupDivision} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.PearlCupDivision, 1));
};


/**
 * @param {?proto.jp.singcolor.PearlCupDivision|undefined} value
 * @return {!proto.jp.singcolor.PearlCupDivisionWithPrize} returns this
*/
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.setDivision = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.PearlCupDivisionWithPrize} returns this
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.clearDivision = function() {
  return this.setDivision(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.hasDivision = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PearlCupPrize prize = 2;
 * @return {?proto.jp.singcolor.PearlCupPrize}
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.getPrize = function() {
  return /** @type{?proto.jp.singcolor.PearlCupPrize} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.PearlCupPrize, 2));
};


/**
 * @param {?proto.jp.singcolor.PearlCupPrize|undefined} value
 * @return {!proto.jp.singcolor.PearlCupDivisionWithPrize} returns this
*/
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.setPrize = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.PearlCupDivisionWithPrize} returns this
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.clearPrize = function() {
  return this.setPrize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupDivisionWithPrize.prototype.hasPrize = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.PearlCupPrize.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.PearlCupPrize.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.PearlCupPrize} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupPrize.toObject = function(includeInstance, msg) {
  var f, obj = {
    pearlCupId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pearlCupDivisionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    platinum: (f = msg.getPlatinum()) && proto.jp.singcolor.PearlCupPrize.Condition.toObject(includeInstance, f),
    gold: (f = msg.getGold()) && proto.jp.singcolor.PearlCupPrize.Condition.toObject(includeInstance, f),
    silver: (f = msg.getSilver()) && proto.jp.singcolor.PearlCupPrize.Condition.toObject(includeInstance, f),
    bronze: (f = msg.getBronze()) && proto.jp.singcolor.PearlCupPrize.Condition.toObject(includeInstance, f),
    spirit: (f = msg.getSpirit()) && proto.jp.singcolor.PearlCupPrize.Condition.toObject(includeInstance, f),
    rewardByOverallDivisionLiveScoreDescription: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.PearlCupPrize}
 */
proto.jp.singcolor.PearlCupPrize.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.PearlCupPrize;
  return proto.jp.singcolor.PearlCupPrize.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.PearlCupPrize} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.PearlCupPrize}
 */
proto.jp.singcolor.PearlCupPrize.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPearlCupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPearlCupDivisionId(value);
      break;
    case 3:
      var value = new proto.jp.singcolor.PearlCupPrize.Condition;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.Condition.deserializeBinaryFromReader);
      msg.setPlatinum(value);
      break;
    case 4:
      var value = new proto.jp.singcolor.PearlCupPrize.Condition;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.Condition.deserializeBinaryFromReader);
      msg.setGold(value);
      break;
    case 5:
      var value = new proto.jp.singcolor.PearlCupPrize.Condition;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.Condition.deserializeBinaryFromReader);
      msg.setSilver(value);
      break;
    case 6:
      var value = new proto.jp.singcolor.PearlCupPrize.Condition;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.Condition.deserializeBinaryFromReader);
      msg.setBronze(value);
      break;
    case 7:
      var value = new proto.jp.singcolor.PearlCupPrize.Condition;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.Condition.deserializeBinaryFromReader);
      msg.setSpirit(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRewardByOverallDivisionLiveScoreDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.PearlCupPrize.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.PearlCupPrize.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.PearlCupPrize} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupPrize.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPearlCupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPearlCupDivisionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlatinum();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.jp.singcolor.PearlCupPrize.Condition.serializeBinaryToWriter
    );
  }
  f = message.getGold();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.jp.singcolor.PearlCupPrize.Condition.serializeBinaryToWriter
    );
  }
  f = message.getSilver();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.jp.singcolor.PearlCupPrize.Condition.serializeBinaryToWriter
    );
  }
  f = message.getBronze();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.jp.singcolor.PearlCupPrize.Condition.serializeBinaryToWriter
    );
  }
  f = message.getSpirit();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.jp.singcolor.PearlCupPrize.Condition.serializeBinaryToWriter
    );
  }
  f = message.getRewardByOverallDivisionLiveScoreDescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.PearlCupPrize.Condition.repeatedFields_ = [3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.PearlCupPrize.Condition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupPrize.Condition.toObject = function(includeInstance, msg) {
  var f, obj = {
    minRank: jspb.Message.getFieldWithDefault(msg, 1, 0),
    minLiveScore: jspb.Message.getFieldWithDefault(msg, 2, 0),
    redList: jspb.Message.toObjectList(msg.getRedList(),
    proto.jp.singcolor.PearlCupPrize.Condition.Amount.toObject, includeInstance),
    blueList: jspb.Message.toObjectList(msg.getBlueList(),
    proto.jp.singcolor.PearlCupPrize.Condition.Amount.toObject, includeInstance),
    rainbowList: jspb.Message.toObjectList(msg.getRainbowList(),
    proto.jp.singcolor.PearlCupPrize.Condition.Amount.toObject, includeInstance),
    color: jspb.Message.getFieldWithDefault(msg, 6, ""),
    minRewardByOverallDivisionLiveScore: jspb.Message.getFieldWithDefault(msg, 7, 0),
    rewardByBasicDescription: jspb.Message.getFieldWithDefault(msg, 9, ""),
    breakThroughBonusRainbowAmount: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition}
 */
proto.jp.singcolor.PearlCupPrize.Condition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.PearlCupPrize.Condition;
  return proto.jp.singcolor.PearlCupPrize.Condition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition}
 */
proto.jp.singcolor.PearlCupPrize.Condition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinRank(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinLiveScore(value);
      break;
    case 3:
      var value = new proto.jp.singcolor.PearlCupPrize.Condition.Amount;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.Condition.Amount.deserializeBinaryFromReader);
      msg.addRed(value);
      break;
    case 4:
      var value = new proto.jp.singcolor.PearlCupPrize.Condition.Amount;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.Condition.Amount.deserializeBinaryFromReader);
      msg.addBlue(value);
      break;
    case 5:
      var value = new proto.jp.singcolor.PearlCupPrize.Condition.Amount;
      reader.readMessage(value,proto.jp.singcolor.PearlCupPrize.Condition.Amount.deserializeBinaryFromReader);
      msg.addRainbow(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setColor(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinRewardByOverallDivisionLiveScore(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRewardByBasicDescription(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBreakThroughBonusRainbowAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.PearlCupPrize.Condition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupPrize.Condition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinRank();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getMinLiveScore();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.jp.singcolor.PearlCupPrize.Condition.Amount.serializeBinaryToWriter
    );
  }
  f = message.getBlueList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.jp.singcolor.PearlCupPrize.Condition.Amount.serializeBinaryToWriter
    );
  }
  f = message.getRainbowList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.jp.singcolor.PearlCupPrize.Condition.Amount.serializeBinaryToWriter
    );
  }
  f = message.getColor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMinRewardByOverallDivisionLiveScore();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getRewardByBasicDescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getBreakThroughBonusRainbowAmount();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.PearlCupPrize.Condition.Amount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition.Amount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.toObject = function(includeInstance, msg) {
  var f, obj = {
    requiredScore: jspb.Message.getFieldWithDefault(msg, 1, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    chanceType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition.Amount}
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.PearlCupPrize.Condition.Amount;
  return proto.jp.singcolor.PearlCupPrize.Condition.Amount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition.Amount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition.Amount}
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequiredScore(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChanceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.PearlCupPrize.Condition.Amount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition.Amount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequiredScore();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getChanceType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 required_score = 1;
 * @return {number}
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.prototype.getRequiredScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition.Amount} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.prototype.setRequiredScore = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition.Amount} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string chance_type = 3;
 * @return {string}
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.prototype.getChanceType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition.Amount} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.Amount.prototype.setChanceType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 min_rank = 1;
 * @return {number}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getMinRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setMinRank = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 min_live_score = 2;
 * @return {number}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getMinLiveScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setMinLiveScore = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated Amount red = 3;
 * @return {!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getRedList = function() {
  return /** @type{!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.jp.singcolor.PearlCupPrize.Condition.Amount, 3));
};


/**
 * @param {!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
*/
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setRedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition.Amount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition.Amount}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.addRed = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.jp.singcolor.PearlCupPrize.Condition.Amount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.clearRedList = function() {
  return this.setRedList([]);
};


/**
 * repeated Amount blue = 4;
 * @return {!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getBlueList = function() {
  return /** @type{!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.jp.singcolor.PearlCupPrize.Condition.Amount, 4));
};


/**
 * @param {!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
*/
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setBlueList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition.Amount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition.Amount}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.addBlue = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.jp.singcolor.PearlCupPrize.Condition.Amount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.clearBlueList = function() {
  return this.setBlueList([]);
};


/**
 * repeated Amount rainbow = 5;
 * @return {!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getRainbowList = function() {
  return /** @type{!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.jp.singcolor.PearlCupPrize.Condition.Amount, 5));
};


/**
 * @param {!Array<!proto.jp.singcolor.PearlCupPrize.Condition.Amount>} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
*/
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setRainbowList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.jp.singcolor.PearlCupPrize.Condition.Amount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition.Amount}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.addRainbow = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.jp.singcolor.PearlCupPrize.Condition.Amount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.clearRainbowList = function() {
  return this.setRainbowList([]);
};


/**
 * optional string color = 6;
 * @return {string}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setColor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 min_reward_by_overall_division_live_score = 7;
 * @return {number}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getMinRewardByOverallDivisionLiveScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setMinRewardByOverallDivisionLiveScore = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string reward_by_basic_description = 9;
 * @return {string}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getRewardByBasicDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setRewardByBasicDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 break_through_bonus_rainbow_amount = 10;
 * @return {number}
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.getBreakThroughBonusRainbowAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupPrize.Condition} returns this
 */
proto.jp.singcolor.PearlCupPrize.Condition.prototype.setBreakThroughBonusRainbowAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string pearl_cup_id = 1;
 * @return {string}
 */
proto.jp.singcolor.PearlCupPrize.prototype.getPearlCupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
 */
proto.jp.singcolor.PearlCupPrize.prototype.setPearlCupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pearl_cup_division_id = 2;
 * @return {string}
 */
proto.jp.singcolor.PearlCupPrize.prototype.getPearlCupDivisionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
 */
proto.jp.singcolor.PearlCupPrize.prototype.setPearlCupDivisionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Condition platinum = 3;
 * @return {?proto.jp.singcolor.PearlCupPrize.Condition}
 */
proto.jp.singcolor.PearlCupPrize.prototype.getPlatinum = function() {
  return /** @type{?proto.jp.singcolor.PearlCupPrize.Condition} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.PearlCupPrize.Condition, 3));
};


/**
 * @param {?proto.jp.singcolor.PearlCupPrize.Condition|undefined} value
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
*/
proto.jp.singcolor.PearlCupPrize.prototype.setPlatinum = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
 */
proto.jp.singcolor.PearlCupPrize.prototype.clearPlatinum = function() {
  return this.setPlatinum(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupPrize.prototype.hasPlatinum = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Condition gold = 4;
 * @return {?proto.jp.singcolor.PearlCupPrize.Condition}
 */
proto.jp.singcolor.PearlCupPrize.prototype.getGold = function() {
  return /** @type{?proto.jp.singcolor.PearlCupPrize.Condition} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.PearlCupPrize.Condition, 4));
};


/**
 * @param {?proto.jp.singcolor.PearlCupPrize.Condition|undefined} value
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
*/
proto.jp.singcolor.PearlCupPrize.prototype.setGold = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
 */
proto.jp.singcolor.PearlCupPrize.prototype.clearGold = function() {
  return this.setGold(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupPrize.prototype.hasGold = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Condition silver = 5;
 * @return {?proto.jp.singcolor.PearlCupPrize.Condition}
 */
proto.jp.singcolor.PearlCupPrize.prototype.getSilver = function() {
  return /** @type{?proto.jp.singcolor.PearlCupPrize.Condition} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.PearlCupPrize.Condition, 5));
};


/**
 * @param {?proto.jp.singcolor.PearlCupPrize.Condition|undefined} value
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
*/
proto.jp.singcolor.PearlCupPrize.prototype.setSilver = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
 */
proto.jp.singcolor.PearlCupPrize.prototype.clearSilver = function() {
  return this.setSilver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupPrize.prototype.hasSilver = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Condition bronze = 6;
 * @return {?proto.jp.singcolor.PearlCupPrize.Condition}
 */
proto.jp.singcolor.PearlCupPrize.prototype.getBronze = function() {
  return /** @type{?proto.jp.singcolor.PearlCupPrize.Condition} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.PearlCupPrize.Condition, 6));
};


/**
 * @param {?proto.jp.singcolor.PearlCupPrize.Condition|undefined} value
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
*/
proto.jp.singcolor.PearlCupPrize.prototype.setBronze = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
 */
proto.jp.singcolor.PearlCupPrize.prototype.clearBronze = function() {
  return this.setBronze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupPrize.prototype.hasBronze = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Condition spirit = 7;
 * @return {?proto.jp.singcolor.PearlCupPrize.Condition}
 */
proto.jp.singcolor.PearlCupPrize.prototype.getSpirit = function() {
  return /** @type{?proto.jp.singcolor.PearlCupPrize.Condition} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.PearlCupPrize.Condition, 7));
};


/**
 * @param {?proto.jp.singcolor.PearlCupPrize.Condition|undefined} value
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
*/
proto.jp.singcolor.PearlCupPrize.prototype.setSpirit = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
 */
proto.jp.singcolor.PearlCupPrize.prototype.clearSpirit = function() {
  return this.setSpirit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupPrize.prototype.hasSpirit = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string reward_by_overall_division_live_score_description = 8;
 * @return {string}
 */
proto.jp.singcolor.PearlCupPrize.prototype.getRewardByOverallDivisionLiveScoreDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupPrize} returns this
 */
proto.jp.singcolor.PearlCupPrize.prototype.setRewardByOverallDivisionLiveScoreDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.AdhocEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.AdhocEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.AdhocEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AdhocEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    adhocEventId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rankingTabName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    eventDetailPageUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    publishStartAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    publishEndAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    startAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
    endAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
    holdingStatus: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.AdhocEvent}
 */
proto.jp.singcolor.AdhocEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.AdhocEvent;
  return proto.jp.singcolor.AdhocEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.AdhocEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.AdhocEvent}
 */
proto.jp.singcolor.AdhocEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdhocEventId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRankingTabName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventDetailPageUrl(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPublishStartAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPublishEndAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndAt(value);
      break;
    case 9:
      var value = /** @type {!proto.jp.singcolor.AdhocEventHoldingStatus} */ (reader.readEnum());
      msg.setHoldingStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.AdhocEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.AdhocEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.AdhocEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AdhocEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdhocEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRankingTabName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEventDetailPageUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPublishStartAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPublishEndAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getStartAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getEndAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getHoldingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional string adhoc_event_id = 1;
 * @return {string}
 */
proto.jp.singcolor.AdhocEvent.prototype.getAdhocEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setAdhocEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.jp.singcolor.AdhocEvent.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ranking_tab_name = 3;
 * @return {string}
 */
proto.jp.singcolor.AdhocEvent.prototype.getRankingTabName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setRankingTabName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string event_detail_page_url = 4;
 * @return {string}
 */
proto.jp.singcolor.AdhocEvent.prototype.getEventDetailPageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setEventDetailPageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 publish_start_at = 5;
 * @return {number}
 */
proto.jp.singcolor.AdhocEvent.prototype.getPublishStartAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setPublishStartAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 publish_end_at = 6;
 * @return {number}
 */
proto.jp.singcolor.AdhocEvent.prototype.getPublishEndAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setPublishEndAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 start_at = 7;
 * @return {number}
 */
proto.jp.singcolor.AdhocEvent.prototype.getStartAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setStartAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 end_at = 8;
 * @return {number}
 */
proto.jp.singcolor.AdhocEvent.prototype.getEndAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setEndAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional AdhocEventHoldingStatus holding_status = 9;
 * @return {!proto.jp.singcolor.AdhocEventHoldingStatus}
 */
proto.jp.singcolor.AdhocEvent.prototype.getHoldingStatus = function() {
  return /** @type {!proto.jp.singcolor.AdhocEventHoldingStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.jp.singcolor.AdhocEventHoldingStatus} value
 * @return {!proto.jp.singcolor.AdhocEvent} returns this
 */
proto.jp.singcolor.AdhocEvent.prototype.setHoldingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.AdhocEventDivision.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.AdhocEventDivision.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.AdhocEventDivision} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AdhocEventDivision.toObject = function(includeInstance, msg) {
  var f, obj = {
    adhocEventId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    adhocEventDivisionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    holdingStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
    startAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    endAt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.AdhocEventDivision}
 */
proto.jp.singcolor.AdhocEventDivision.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.AdhocEventDivision;
  return proto.jp.singcolor.AdhocEventDivision.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.AdhocEventDivision} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.AdhocEventDivision}
 */
proto.jp.singcolor.AdhocEventDivision.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdhocEventId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdhocEventDivisionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.jp.singcolor.AdhocEventDivisionHoldingStatus} */ (reader.readEnum());
      msg.setHoldingStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.AdhocEventDivision.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.AdhocEventDivision.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.AdhocEventDivision} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.AdhocEventDivision.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdhocEventId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdhocEventDivisionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHoldingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStartAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getEndAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string adhoc_event_id = 1;
 * @return {string}
 */
proto.jp.singcolor.AdhocEventDivision.prototype.getAdhocEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AdhocEventDivision} returns this
 */
proto.jp.singcolor.AdhocEventDivision.prototype.setAdhocEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string adhoc_event_division_id = 2;
 * @return {string}
 */
proto.jp.singcolor.AdhocEventDivision.prototype.getAdhocEventDivisionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AdhocEventDivision} returns this
 */
proto.jp.singcolor.AdhocEventDivision.prototype.setAdhocEventDivisionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.jp.singcolor.AdhocEventDivision.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.AdhocEventDivision} returns this
 */
proto.jp.singcolor.AdhocEventDivision.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional AdhocEventDivisionHoldingStatus holding_status = 4;
 * @return {!proto.jp.singcolor.AdhocEventDivisionHoldingStatus}
 */
proto.jp.singcolor.AdhocEventDivision.prototype.getHoldingStatus = function() {
  return /** @type {!proto.jp.singcolor.AdhocEventDivisionHoldingStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.jp.singcolor.AdhocEventDivisionHoldingStatus} value
 * @return {!proto.jp.singcolor.AdhocEventDivision} returns this
 */
proto.jp.singcolor.AdhocEventDivision.prototype.setHoldingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 start_at = 5;
 * @return {number}
 */
proto.jp.singcolor.AdhocEventDivision.prototype.getStartAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AdhocEventDivision} returns this
 */
proto.jp.singcolor.AdhocEventDivision.prototype.setStartAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 end_at = 6;
 * @return {number}
 */
proto.jp.singcolor.AdhocEventDivision.prototype.getEndAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.AdhocEventDivision} returns this
 */
proto.jp.singcolor.AdhocEventDivision.prototype.setEndAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.PearlCupGearOption.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.PearlCupGearOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.PearlCupGearOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupGearOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    gearType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    displayLiveScoreRate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    displayDiamondRate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    rainbowPearlAmount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isSelectable: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.PearlCupGearOption}
 */
proto.jp.singcolor.PearlCupGearOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.PearlCupGearOption;
  return proto.jp.singcolor.PearlCupGearOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.PearlCupGearOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.PearlCupGearOption}
 */
proto.jp.singcolor.PearlCupGearOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.jp.singcolor.GearType} */ (reader.readEnum());
      msg.setGearType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayLiveScoreRate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayDiamondRate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRainbowPearlAmount(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSelectable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.PearlCupGearOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.PearlCupGearOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.PearlCupGearOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.PearlCupGearOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGearType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDisplayLiveScoreRate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDisplayDiamondRate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRainbowPearlAmount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getIsSelectable();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional GearType gear_type = 1;
 * @return {!proto.jp.singcolor.GearType}
 */
proto.jp.singcolor.PearlCupGearOption.prototype.getGearType = function() {
  return /** @type {!proto.jp.singcolor.GearType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.jp.singcolor.GearType} value
 * @return {!proto.jp.singcolor.PearlCupGearOption} returns this
 */
proto.jp.singcolor.PearlCupGearOption.prototype.setGearType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string display_live_score_rate = 2;
 * @return {string}
 */
proto.jp.singcolor.PearlCupGearOption.prototype.getDisplayLiveScoreRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupGearOption} returns this
 */
proto.jp.singcolor.PearlCupGearOption.prototype.setDisplayLiveScoreRate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string display_diamond_rate = 3;
 * @return {string}
 */
proto.jp.singcolor.PearlCupGearOption.prototype.getDisplayDiamondRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.PearlCupGearOption} returns this
 */
proto.jp.singcolor.PearlCupGearOption.prototype.setDisplayDiamondRate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 rainbow_pearl_amount = 4;
 * @return {number}
 */
proto.jp.singcolor.PearlCupGearOption.prototype.getRainbowPearlAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.PearlCupGearOption} returns this
 */
proto.jp.singcolor.PearlCupGearOption.prototype.setRainbowPearlAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_selectable = 5;
 * @return {boolean}
 */
proto.jp.singcolor.PearlCupGearOption.prototype.getIsSelectable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.PearlCupGearOption} returns this
 */
proto.jp.singcolor.PearlCupGearOption.prototype.setIsSelectable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserDevice.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserDevice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserDevice.toObject = function(includeInstance, msg) {
  var f, obj = {
    deviceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    permitMultipleUser: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserDevice}
 */
proto.jp.singcolor.UserDevice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserDevice;
  return proto.jp.singcolor.UserDevice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserDevice}
 */
proto.jp.singcolor.UserDevice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPermitMultipleUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserDevice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserDevice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserDevice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPermitMultipleUser();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string device_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserDevice.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserDevice} returns this
 */
proto.jp.singcolor.UserDevice.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.jp.singcolor.UserDevice.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserDevice} returns this
 */
proto.jp.singcolor.UserDevice.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool permit_multiple_user = 3;
 * @return {boolean}
 */
proto.jp.singcolor.UserDevice.prototype.getPermitMultipleUser = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserDevice} returns this
 */
proto.jp.singcolor.UserDevice.prototype.setPermitMultipleUser = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Device.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Device.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Device} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Device.toObject = function(includeInstance, msg) {
  var f, obj = {
    deviceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    os: jspb.Message.getFieldWithDefault(msg, 2, ""),
    osVersion: jspb.Message.getFieldWithDefault(msg, 3, ""),
    platform: jspb.Message.getFieldWithDefault(msg, 4, ""),
    model: jspb.Message.getFieldWithDefault(msg, 5, ""),
    appVersion: jspb.Message.getFieldWithDefault(msg, 6, ""),
    appVersionCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    appId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    timezone: jspb.Message.getFieldWithDefault(msg, 9, ""),
    language: jspb.Message.getFieldWithDefault(msg, 10, ""),
    location: jspb.Message.getFieldWithDefault(msg, 11, ""),
    registrationToken: jspb.Message.getFieldWithDefault(msg, 12, ""),
    pushNotifiable: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Device}
 */
proto.jp.singcolor.Device.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Device;
  return proto.jp.singcolor.Device.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Device} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Device}
 */
proto.jp.singcolor.Device.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOs(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOsVersion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppVersion(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppVersionCode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocation(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistrationToken(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPushNotifiable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Device.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Device.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Device} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Device.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOs();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOsVersion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAppVersion();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAppVersionCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAppId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRegistrationToken();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPushNotifiable();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional string device_id = 1;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getDeviceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setDeviceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string os = 2;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getOs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setOs = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string os_version = 3;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getOsVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setOsVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string platform = 4;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string model = 5;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string app_version = 6;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getAppVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setAppVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string app_version_code = 7;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getAppVersionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setAppVersionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string app_id = 8;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getAppId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setAppId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string timezone = 9;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string language = 10;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string location = 11;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getLocation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setLocation = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string registration_token = 12;
 * @return {string}
 */
proto.jp.singcolor.Device.prototype.getRegistrationToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setRegistrationToken = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool push_notifiable = 13;
 * @return {boolean}
 */
proto.jp.singcolor.Device.prototype.getPushNotifiable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.Device} returns this
 */
proto.jp.singcolor.Device.prototype.setPushNotifiable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.LiverRequestedSongHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.LiverRequestedSongHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.LiverRequestedSongHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && proto.jp.singcolor.User.toObject(includeInstance, f),
    song: (f = msg.getSong()) && karaoke_entity_pb.Song.toObject(includeInstance, f),
    createdAt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.LiverRequestedSongHistory}
 */
proto.jp.singcolor.LiverRequestedSongHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.LiverRequestedSongHistory;
  return proto.jp.singcolor.LiverRequestedSongHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.LiverRequestedSongHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.LiverRequestedSongHistory}
 */
proto.jp.singcolor.LiverRequestedSongHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.jp.singcolor.User;
      reader.readMessage(value,proto.jp.singcolor.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = new karaoke_entity_pb.Song;
      reader.readMessage(value,karaoke_entity_pb.Song.deserializeBinaryFromReader);
      msg.setSong(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.LiverRequestedSongHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.LiverRequestedSongHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.LiverRequestedSongHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.jp.singcolor.User.serializeBinaryToWriter
    );
  }
  f = message.getSong();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      karaoke_entity_pb.Song.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional User user = 1;
 * @return {?proto.jp.singcolor.User}
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.getUser = function() {
  return /** @type{?proto.jp.singcolor.User} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.User, 1));
};


/**
 * @param {?proto.jp.singcolor.User|undefined} value
 * @return {!proto.jp.singcolor.LiverRequestedSongHistory} returns this
*/
proto.jp.singcolor.LiverRequestedSongHistory.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.LiverRequestedSongHistory} returns this
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Song song = 2;
 * @return {?proto.jp.singcolor.Song}
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.getSong = function() {
  return /** @type{?proto.jp.singcolor.Song} */ (
    jspb.Message.getWrapperField(this, karaoke_entity_pb.Song, 2));
};


/**
 * @param {?proto.jp.singcolor.Song|undefined} value
 * @return {!proto.jp.singcolor.LiverRequestedSongHistory} returns this
*/
proto.jp.singcolor.LiverRequestedSongHistory.prototype.setSong = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.LiverRequestedSongHistory} returns this
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.clearSong = function() {
  return this.setSong(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.hasSong = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 created_at = 3;
 * @return {number}
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.LiverRequestedSongHistory} returns this
 */
proto.jp.singcolor.LiverRequestedSongHistory.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.ListenerMembershipInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.ListenerMembershipInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.ListenerMembershipInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.ListenerMembershipInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    liverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    listenerId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isMembership: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.ListenerMembershipInfo}
 */
proto.jp.singcolor.ListenerMembershipInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.ListenerMembershipInfo;
  return proto.jp.singcolor.ListenerMembershipInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.ListenerMembershipInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.ListenerMembershipInfo}
 */
proto.jp.singcolor.ListenerMembershipInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiverId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setListenerId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMembership(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.ListenerMembershipInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.ListenerMembershipInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.ListenerMembershipInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.ListenerMembershipInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiverId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getListenerId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsMembership();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string liver_id = 1;
 * @return {string}
 */
proto.jp.singcolor.ListenerMembershipInfo.prototype.getLiverId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.ListenerMembershipInfo} returns this
 */
proto.jp.singcolor.ListenerMembershipInfo.prototype.setLiverId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string listener_id = 2;
 * @return {string}
 */
proto.jp.singcolor.ListenerMembershipInfo.prototype.getListenerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.ListenerMembershipInfo} returns this
 */
proto.jp.singcolor.ListenerMembershipInfo.prototype.setListenerId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_membership = 3;
 * @return {boolean}
 */
proto.jp.singcolor.ListenerMembershipInfo.prototype.getIsMembership = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.ListenerMembershipInfo} returns this
 */
proto.jp.singcolor.ListenerMembershipInfo.prototype.setIsMembership = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.Moderator.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.Moderator.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.Moderator} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Moderator.toObject = function(includeInstance, msg) {
  var f, obj = {
    userItem: (f = msg.getUserItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    endAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    tenureCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.Moderator}
 */
proto.jp.singcolor.Moderator.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.Moderator;
  return proto.jp.singcolor.Moderator.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.Moderator} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.Moderator}
 */
proto.jp.singcolor.Moderator.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setUserItem(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndAt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTenureCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.Moderator.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.Moderator.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.Moderator} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.Moderator.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getEndAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTenureCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional UserItem user_item = 1;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.Moderator.prototype.getUserItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 1));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.Moderator} returns this
*/
proto.jp.singcolor.Moderator.prototype.setUserItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.Moderator} returns this
 */
proto.jp.singcolor.Moderator.prototype.clearUserItem = function() {
  return this.setUserItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.Moderator.prototype.hasUserItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 end_at = 2;
 * @return {number}
 */
proto.jp.singcolor.Moderator.prototype.getEndAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Moderator} returns this
 */
proto.jp.singcolor.Moderator.prototype.setEndAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 tenure_count = 3;
 * @return {number}
 */
proto.jp.singcolor.Moderator.prototype.getTenureCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.Moderator} returns this
 */
proto.jp.singcolor.Moderator.prototype.setTenureCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.ListenerSongFaveThumbnail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.ListenerSongFaveThumbnail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    imageUrls: (f = msg.getImageUrls()) && photo_entity_pb.ImageURL.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.ListenerSongFaveThumbnail}
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.ListenerSongFaveThumbnail;
  return proto.jp.singcolor.ListenerSongFaveThumbnail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.ListenerSongFaveThumbnail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.ListenerSongFaveThumbnail}
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new photo_entity_pb.ImageURL;
      reader.readMessage(value,photo_entity_pb.ImageURL.deserializeBinaryFromReader);
      msg.setImageUrls(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.ListenerSongFaveThumbnail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.ListenerSongFaveThumbnail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImageUrls();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      photo_entity_pb.ImageURL.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.ListenerSongFaveThumbnail} returns this
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ImageURL image_urls = 2;
 * @return {?proto.jp.singcolor.ImageURL}
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.prototype.getImageUrls = function() {
  return /** @type{?proto.jp.singcolor.ImageURL} */ (
    jspb.Message.getWrapperField(this, photo_entity_pb.ImageURL, 2));
};


/**
 * @param {?proto.jp.singcolor.ImageURL|undefined} value
 * @return {!proto.jp.singcolor.ListenerSongFaveThumbnail} returns this
*/
proto.jp.singcolor.ListenerSongFaveThumbnail.prototype.setImageUrls = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.ListenerSongFaveThumbnail} returns this
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.prototype.clearImageUrls = function() {
  return this.setImageUrls(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.ListenerSongFaveThumbnail.prototype.hasImageUrls = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.LiverEvaluationCriterionImportance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionImportance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.toObject = function(includeInstance, msg) {
  var f, obj = {
    liverEvaluationCriterionImportanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    thumbnailImageUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    defaultSelectedOrder: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionImportance}
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.LiverEvaluationCriterionImportance;
  return proto.jp.singcolor.LiverEvaluationCriterionImportance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionImportance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionImportance}
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiverEvaluationCriterionImportanceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailImageUrl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDefaultSelectedOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.LiverEvaluationCriterionImportance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionImportance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiverEvaluationCriterionImportanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getThumbnailImageUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDefaultSelectedOrder();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string liver_evaluation_criterion_importance_id = 1;
 * @return {string}
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.getLiverEvaluationCriterionImportanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionImportance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.setLiverEvaluationCriterionImportanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionImportance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string thumbnail_image_url = 3;
 * @return {string}
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.getThumbnailImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionImportance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.setThumbnailImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 default_selected_order = 4;
 * @return {number}
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.getDefaultSelectedOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionImportance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionImportance.prototype.setDefaultSelectedOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.LiverEvaluationCriterionAvoidance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.toObject = function(includeInstance, msg) {
  var f, obj = {
    liverEvaluationCriterionAvoidanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    thumbnailImageUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    defaultLevel: jspb.Message.getFieldWithDefault(msg, 4, 0),
    defaultIfForce: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    singScoreFilterSuggestionsList: jspb.Message.toObjectList(msg.getSingScoreFilterSuggestionsList(),
    proto.jp.singcolor.SingScoreFilterSuggestion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.LiverEvaluationCriterionAvoidance;
  return proto.jp.singcolor.LiverEvaluationCriterionAvoidance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiverEvaluationCriterionAvoidanceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailImageUrl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDefaultLevel(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDefaultIfForce(value);
      break;
    case 6:
      var value = new proto.jp.singcolor.SingScoreFilterSuggestion;
      reader.readMessage(value,proto.jp.singcolor.SingScoreFilterSuggestion.deserializeBinaryFromReader);
      msg.addSingScoreFilterSuggestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.LiverEvaluationCriterionAvoidance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiverEvaluationCriterionAvoidanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getThumbnailImageUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDefaultLevel();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDefaultIfForce();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getSingScoreFilterSuggestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.jp.singcolor.SingScoreFilterSuggestion.serializeBinaryToWriter
    );
  }
};


/**
 * optional string liver_evaluation_criterion_avoidance_id = 1;
 * @return {string}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.getLiverEvaluationCriterionAvoidanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.setLiverEvaluationCriterionAvoidanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string thumbnail_image_url = 3;
 * @return {string}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.getThumbnailImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.setThumbnailImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 default_level = 4;
 * @return {number}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.getDefaultLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.setDefaultLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool default_if_force = 5;
 * @return {boolean}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.getDefaultIfForce = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.setDefaultIfForce = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated SingScoreFilterSuggestion sing_score_filter_suggestions = 6;
 * @return {!Array<!proto.jp.singcolor.SingScoreFilterSuggestion>}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.getSingScoreFilterSuggestionsList = function() {
  return /** @type{!Array<!proto.jp.singcolor.SingScoreFilterSuggestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.jp.singcolor.SingScoreFilterSuggestion, 6));
};


/**
 * @param {!Array<!proto.jp.singcolor.SingScoreFilterSuggestion>} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} returns this
*/
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.setSingScoreFilterSuggestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.jp.singcolor.SingScoreFilterSuggestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.jp.singcolor.SingScoreFilterSuggestion}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.addSingScoreFilterSuggestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.jp.singcolor.SingScoreFilterSuggestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidance} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidance.prototype.clearSingScoreFilterSuggestionsList = function() {
  return this.setSingScoreFilterSuggestionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.SingScoreFilterOption.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.SingScoreFilterOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.SingScoreFilterOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.SingScoreFilterOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    optionLabel: jspb.Message.getFieldWithDefault(msg, 2, ""),
    upperPercentage: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.SingScoreFilterOption}
 */
proto.jp.singcolor.SingScoreFilterOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.SingScoreFilterOption;
  return proto.jp.singcolor.SingScoreFilterOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.SingScoreFilterOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.SingScoreFilterOption}
 */
proto.jp.singcolor.SingScoreFilterOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpperPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.SingScoreFilterOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.SingScoreFilterOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.SingScoreFilterOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.SingScoreFilterOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOptionLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUpperPercentage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.jp.singcolor.SingScoreFilterOption.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.SingScoreFilterOption} returns this
 */
proto.jp.singcolor.SingScoreFilterOption.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string option_label = 2;
 * @return {string}
 */
proto.jp.singcolor.SingScoreFilterOption.prototype.getOptionLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.SingScoreFilterOption} returns this
 */
proto.jp.singcolor.SingScoreFilterOption.prototype.setOptionLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string upper_percentage = 3;
 * @return {string}
 */
proto.jp.singcolor.SingScoreFilterOption.prototype.getUpperPercentage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.SingScoreFilterOption} returns this
 */
proto.jp.singcolor.SingScoreFilterOption.prototype.setUpperPercentage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.SingScoreFilterSuggestion.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.SingScoreFilterSuggestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.SingScoreFilterSuggestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.SingScoreFilterSuggestion.toObject = function(includeInstance, msg) {
  var f, obj = {
    level: jspb.Message.getFieldWithDefault(msg, 1, 0),
    option: (f = msg.getOption()) && proto.jp.singcolor.SingScoreFilterOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.SingScoreFilterSuggestion}
 */
proto.jp.singcolor.SingScoreFilterSuggestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.SingScoreFilterSuggestion;
  return proto.jp.singcolor.SingScoreFilterSuggestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.SingScoreFilterSuggestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.SingScoreFilterSuggestion}
 */
proto.jp.singcolor.SingScoreFilterSuggestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.SingScoreFilterOption;
      reader.readMessage(value,proto.jp.singcolor.SingScoreFilterOption.deserializeBinaryFromReader);
      msg.setOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.SingScoreFilterSuggestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.SingScoreFilterSuggestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.SingScoreFilterSuggestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.SingScoreFilterSuggestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOption();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.SingScoreFilterOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 level = 1;
 * @return {number}
 */
proto.jp.singcolor.SingScoreFilterSuggestion.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.SingScoreFilterSuggestion} returns this
 */
proto.jp.singcolor.SingScoreFilterSuggestion.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional SingScoreFilterOption option = 2;
 * @return {?proto.jp.singcolor.SingScoreFilterOption}
 */
proto.jp.singcolor.SingScoreFilterSuggestion.prototype.getOption = function() {
  return /** @type{?proto.jp.singcolor.SingScoreFilterOption} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.SingScoreFilterOption, 2));
};


/**
 * @param {?proto.jp.singcolor.SingScoreFilterOption|undefined} value
 * @return {!proto.jp.singcolor.SingScoreFilterSuggestion} returns this
*/
proto.jp.singcolor.SingScoreFilterSuggestion.prototype.setOption = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.SingScoreFilterSuggestion} returns this
 */
proto.jp.singcolor.SingScoreFilterSuggestion.prototype.clearOption = function() {
  return this.setOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.SingScoreFilterSuggestion.prototype.hasOption = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.toObject = function(includeInstance, msg) {
  var f, obj = {
    liverEvaluationCriterionAvoidanceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    level: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel;
  return proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiverEvaluationCriterionAvoidanceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiverEvaluationCriterionAvoidanceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string liver_evaluation_criterion_avoidance_id = 1;
 * @return {string}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.prototype.getLiverEvaluationCriterionAvoidanceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.prototype.setLiverEvaluationCriterionAvoidanceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 level = 2;
 * @return {number}
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.prototype.getLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel} returns this
 */
proto.jp.singcolor.LiverEvaluationCriterionAvoidanceLevel.prototype.setLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserTimelineVisibilityExclusion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserTimelineVisibilityExclusion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.toObject = function(includeInstance, msg) {
  var f, obj = {
    listenerViewingStanceToAvoid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    avoidMuteListener: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    avoidCoinPurposeListener: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    avoidRarelyUseSpecificCoinListener: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    avoidFrequentlyReportedOrBlockedListener: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserTimelineVisibilityExclusion}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserTimelineVisibilityExclusion;
  return proto.jp.singcolor.UserTimelineVisibilityExclusion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserTimelineVisibilityExclusion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserTimelineVisibilityExclusion}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.jp.singcolor.ListenerViewingStanceToAvoid} */ (reader.readEnum());
      msg.setListenerViewingStanceToAvoid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvoidMuteListener(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvoidCoinPurposeListener(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvoidRarelyUseSpecificCoinListener(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvoidFrequentlyReportedOrBlockedListener(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserTimelineVisibilityExclusion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserTimelineVisibilityExclusion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListenerViewingStanceToAvoid();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAvoidMuteListener();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getAvoidCoinPurposeListener();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAvoidRarelyUseSpecificCoinListener();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAvoidFrequentlyReportedOrBlockedListener();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional ListenerViewingStanceToAvoid listener_viewing_stance_to_avoid = 1;
 * @return {!proto.jp.singcolor.ListenerViewingStanceToAvoid}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.getListenerViewingStanceToAvoid = function() {
  return /** @type {!proto.jp.singcolor.ListenerViewingStanceToAvoid} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.jp.singcolor.ListenerViewingStanceToAvoid} value
 * @return {!proto.jp.singcolor.UserTimelineVisibilityExclusion} returns this
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.setListenerViewingStanceToAvoid = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool avoid_mute_listener = 2;
 * @return {boolean}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.getAvoidMuteListener = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserTimelineVisibilityExclusion} returns this
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.setAvoidMuteListener = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool avoid_coin_purpose_listener = 3;
 * @return {boolean}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.getAvoidCoinPurposeListener = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserTimelineVisibilityExclusion} returns this
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.setAvoidCoinPurposeListener = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool avoid_rarely_use_specific_coin_listener = 4;
 * @return {boolean}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.getAvoidRarelyUseSpecificCoinListener = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserTimelineVisibilityExclusion} returns this
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.setAvoidRarelyUseSpecificCoinListener = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool avoid_frequently_reported_or_blocked_listener = 5;
 * @return {boolean}
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.getAvoidFrequentlyReportedOrBlockedListener = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.jp.singcolor.UserTimelineVisibilityExclusion} returns this
 */
proto.jp.singcolor.UserTimelineVisibilityExclusion.prototype.setAvoidFrequentlyReportedOrBlockedListener = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.InterestedLiver.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.InterestedLiver.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.InterestedLiver} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.InterestedLiver.toObject = function(includeInstance, msg) {
  var f, obj = {
    liverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    interesetedLiverItem: (f = msg.getInteresetedLiverItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f),
    createdAt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.InterestedLiver}
 */
proto.jp.singcolor.InterestedLiver.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.InterestedLiver;
  return proto.jp.singcolor.InterestedLiver.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.InterestedLiver} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.InterestedLiver}
 */
proto.jp.singcolor.InterestedLiver.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiverId(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setInteresetedLiverItem(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.InterestedLiver.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.InterestedLiver.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.InterestedLiver} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.InterestedLiver.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiverId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInteresetedLiverItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string liver_id = 1;
 * @return {string}
 */
proto.jp.singcolor.InterestedLiver.prototype.getLiverId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.InterestedLiver} returns this
 */
proto.jp.singcolor.InterestedLiver.prototype.setLiverId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UserItem intereseted_liver_item = 2;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.InterestedLiver.prototype.getInteresetedLiverItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 2));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.InterestedLiver} returns this
*/
proto.jp.singcolor.InterestedLiver.prototype.setInteresetedLiverItem = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.InterestedLiver} returns this
 */
proto.jp.singcolor.InterestedLiver.prototype.clearInteresetedLiverItem = function() {
  return this.setInteresetedLiverItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.InterestedLiver.prototype.hasInteresetedLiverItem = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 created_at = 3;
 * @return {number}
 */
proto.jp.singcolor.InterestedLiver.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.InterestedLiver} returns this
 */
proto.jp.singcolor.InterestedLiver.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.HiddenLiver.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.HiddenLiver.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.HiddenLiver} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.HiddenLiver.toObject = function(includeInstance, msg) {
  var f, obj = {
    liverId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hiddenLiverItem: (f = msg.getHiddenLiverItem()) && proto.jp.singcolor.UserItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.HiddenLiver}
 */
proto.jp.singcolor.HiddenLiver.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.HiddenLiver;
  return proto.jp.singcolor.HiddenLiver.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.HiddenLiver} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.HiddenLiver}
 */
proto.jp.singcolor.HiddenLiver.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiverId(value);
      break;
    case 2:
      var value = new proto.jp.singcolor.UserItem;
      reader.readMessage(value,proto.jp.singcolor.UserItem.deserializeBinaryFromReader);
      msg.setHiddenLiverItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.HiddenLiver.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.HiddenLiver.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.HiddenLiver} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.HiddenLiver.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLiverId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHiddenLiverItem();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.jp.singcolor.UserItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string liver_id = 1;
 * @return {string}
 */
proto.jp.singcolor.HiddenLiver.prototype.getLiverId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.HiddenLiver} returns this
 */
proto.jp.singcolor.HiddenLiver.prototype.setLiverId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UserItem hidden_liver_item = 2;
 * @return {?proto.jp.singcolor.UserItem}
 */
proto.jp.singcolor.HiddenLiver.prototype.getHiddenLiverItem = function() {
  return /** @type{?proto.jp.singcolor.UserItem} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserItem, 2));
};


/**
 * @param {?proto.jp.singcolor.UserItem|undefined} value
 * @return {!proto.jp.singcolor.HiddenLiver} returns this
*/
proto.jp.singcolor.HiddenLiver.prototype.setHiddenLiverItem = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.HiddenLiver} returns this
 */
proto.jp.singcolor.HiddenLiver.prototype.clearHiddenLiverItem = function() {
  return this.setHiddenLiverItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.HiddenLiver.prototype.hasHiddenLiverItem = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.EnterPreviewSongSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.EnterPreviewSongSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.EnterPreviewSongSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    song: (f = msg.getSong()) && karaoke_entity_pb.Song.toObject(includeInstance, f),
    order: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sungAt: jspb.Message.getFieldWithDefault(msg, 3, 0),
    userSingHistoryId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.EnterPreviewSongSetting}
 */
proto.jp.singcolor.EnterPreviewSongSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.EnterPreviewSongSetting;
  return proto.jp.singcolor.EnterPreviewSongSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.EnterPreviewSongSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.EnterPreviewSongSetting}
 */
proto.jp.singcolor.EnterPreviewSongSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new karaoke_entity_pb.Song;
      reader.readMessage(value,karaoke_entity_pb.Song.deserializeBinaryFromReader);
      msg.setSong(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrder(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSungAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserSingHistoryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.EnterPreviewSongSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.EnterPreviewSongSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.EnterPreviewSongSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSong();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      karaoke_entity_pb.Song.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSungAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getUserSingHistoryId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional Song song = 1;
 * @return {?proto.jp.singcolor.Song}
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.getSong = function() {
  return /** @type{?proto.jp.singcolor.Song} */ (
    jspb.Message.getWrapperField(this, karaoke_entity_pb.Song, 1));
};


/**
 * @param {?proto.jp.singcolor.Song|undefined} value
 * @return {!proto.jp.singcolor.EnterPreviewSongSetting} returns this
*/
proto.jp.singcolor.EnterPreviewSongSetting.prototype.setSong = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.EnterPreviewSongSetting} returns this
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.clearSong = function() {
  return this.setSong(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.hasSong = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 order = 2;
 * @return {number}
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.EnterPreviewSongSetting} returns this
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.setOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 sung_at = 3;
 * @return {number}
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.getSungAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.EnterPreviewSongSetting} returns this
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.setSungAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string user_sing_history_id = 4;
 * @return {string}
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.getUserSingHistoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.EnterPreviewSongSetting} returns this
 */
proto.jp.singcolor.EnterPreviewSongSetting.prototype.setUserSingHistoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserSingHistoryClip.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserSingHistoryClip} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserSingHistoryClip.toObject = function(includeInstance, msg) {
  var f, obj = {
    userSingHistoryId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sungAt: jspb.Message.getFieldWithDefault(msg, 2, 0),
    clipStartTimeOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    clipEndTimeOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    recordingAudioUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    recordingVideoUrl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    liveMode: jspb.Message.getFieldWithDefault(msg, 7, 0),
    liveTitle: jspb.Message.getFieldWithDefault(msg, 8, ""),
    range: (f = msg.getRange()) && proto.jp.singcolor.UserSingRange.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserSingHistoryClip}
 */
proto.jp.singcolor.UserSingHistoryClip.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserSingHistoryClip;
  return proto.jp.singcolor.UserSingHistoryClip.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserSingHistoryClip} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserSingHistoryClip}
 */
proto.jp.singcolor.UserSingHistoryClip.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserSingHistoryId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSungAt(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setClipStartTimeOffset(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setClipEndTimeOffset(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordingAudioUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordingVideoUrl(value);
      break;
    case 7:
      var value = /** @type {!proto.jp.singcolor.LiveMode} */ (reader.readEnum());
      msg.setLiveMode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiveTitle(value);
      break;
    case 9:
      var value = new proto.jp.singcolor.UserSingRange;
      reader.readMessage(value,proto.jp.singcolor.UserSingRange.deserializeBinaryFromReader);
      msg.setRange(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserSingHistoryClip.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserSingHistoryClip} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserSingHistoryClip.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserSingHistoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSungAt();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getClipStartTimeOffset();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getClipEndTimeOffset();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getRecordingAudioUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRecordingVideoUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLiveMode();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getLiveTitle();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRange();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.jp.singcolor.UserSingRange.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_sing_history_id = 1;
 * @return {string}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getUserSingHistoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.setUserSingHistoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 sung_at = 2;
 * @return {number}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getSungAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.setSungAt = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional float clip_start_time_offset = 3;
 * @return {number}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getClipStartTimeOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.setClipStartTimeOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float clip_end_time_offset = 4;
 * @return {number}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getClipEndTimeOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.setClipEndTimeOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string recording_audio_url = 5;
 * @return {string}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getRecordingAudioUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.setRecordingAudioUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string recording_video_url = 6;
 * @return {string}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getRecordingVideoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.setRecordingVideoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional LiveMode live_mode = 7;
 * @return {!proto.jp.singcolor.LiveMode}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getLiveMode = function() {
  return /** @type {!proto.jp.singcolor.LiveMode} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.jp.singcolor.LiveMode} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.setLiveMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string live_title = 8;
 * @return {string}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getLiveTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.setLiveTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional UserSingRange range = 9;
 * @return {?proto.jp.singcolor.UserSingRange}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.getRange = function() {
  return /** @type{?proto.jp.singcolor.UserSingRange} */ (
    jspb.Message.getWrapperField(this, proto.jp.singcolor.UserSingRange, 9));
};


/**
 * @param {?proto.jp.singcolor.UserSingRange|undefined} value
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
*/
proto.jp.singcolor.UserSingHistoryClip.prototype.setRange = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.jp.singcolor.UserSingHistoryClip} returns this
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.clearRange = function() {
  return this.setRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.jp.singcolor.UserSingHistoryClip.prototype.hasRange = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.jp.singcolor.UserSingRange.prototype.toObject = function(opt_includeInstance) {
  return proto.jp.singcolor.UserSingRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.jp.singcolor.UserSingRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserSingRange.toObject = function(includeInstance, msg) {
  var f, obj = {
    hlsUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    singStartTimeOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    singEndTimeOffset: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.jp.singcolor.UserSingRange}
 */
proto.jp.singcolor.UserSingRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.jp.singcolor.UserSingRange;
  return proto.jp.singcolor.UserSingRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.jp.singcolor.UserSingRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.jp.singcolor.UserSingRange}
 */
proto.jp.singcolor.UserSingRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHlsUrl(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSingStartTimeOffset(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSingEndTimeOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.jp.singcolor.UserSingRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.jp.singcolor.UserSingRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.jp.singcolor.UserSingRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.jp.singcolor.UserSingRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHlsUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSingStartTimeOffset();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getSingEndTimeOffset();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional string hls_url = 1;
 * @return {string}
 */
proto.jp.singcolor.UserSingRange.prototype.getHlsUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.jp.singcolor.UserSingRange} returns this
 */
proto.jp.singcolor.UserSingRange.prototype.setHlsUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional float sing_start_time_offset = 2;
 * @return {number}
 */
proto.jp.singcolor.UserSingRange.prototype.getSingStartTimeOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserSingRange} returns this
 */
proto.jp.singcolor.UserSingRange.prototype.setSingStartTimeOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float sing_end_time_offset = 3;
 * @return {number}
 */
proto.jp.singcolor.UserSingRange.prototype.getSingEndTimeOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.jp.singcolor.UserSingRange} returns this
 */
proto.jp.singcolor.UserSingRange.prototype.setSingEndTimeOffset = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.jp.singcolor.Gender = {
  GENDER_SECRET: 0,
  GENDER_MALE: 1,
  GENDER_FEMALE: 2,
  GENDER_PANGENDER: 4,
  GENDER_BIGENDER: 5,
  GENDER_NON_BINARY: 6,
  GENDER_TRANS_MALE: 7,
  GENDER_TRANS_FEMALE: 8,
  GENDER_FLUID: 9,
  GENDER_GENDERQUEER: 10,
  GENDER_TWO_SPIRIT: 11,
  GENDER_NEUTROIS: 12,
  GENDER_NONCONFORMING: 13,
  GENDER_QUESTIONING: 14,
  GENDER_UNCATEGORIZED: 15,
  GENDER_HIDDEN: 3
};

/**
 * @enum {number}
 */
proto.jp.singcolor.UserWithdrawalStatus = {
  USER_WITHDRAWAL_STATUS_UNSPECIFIED: 0,
  USER_WITHDRAWAL_STATUS_NOT_WITHDRAWN: 1,
  USER_WITHDRAWAL_STATUS_WITHDRAWN_REVOCABLE: 2,
  USER_WITHDRAWAL_STATUS_WITHDRAWN_IRREVOCABLE: 3
};

/**
 * @enum {number}
 */
proto.jp.singcolor.ViewingStance = {
  VIEWING_STANCE_UNSPECIFIED: 0,
  VIEWING_STANCE_WELCOME_TO_TALK_TO_US: 1,
  VIEWING_STANCE_MY_OWN_PACE: 2,
  VIEWING_STANCE_SLIGHTLY_SILENT: 3,
  VIEWING_STANCE_THINK_OF_IT_AS_AIR: 4
};

/**
 * @enum {number}
 */
proto.jp.singcolor.ListenerViewingStanceToAvoid = {
  LISTENER_VIEWING_STANCE_TO_AVOID_UNSPECIFIED: 0,
  LISTENER_VIEWING_STANCE_TO_AVOID_AIR: 1,
  LISTENER_VIEWING_STANCE_TO_AVOID_SLIGHTLY_SILENT_AND_AIR: 2,
  LISTENER_VIEWING_STANCE_TO_AVOID_SILENT: 3
};

/**
 * @enum {number}
 */
proto.jp.singcolor.ViewingArea = {
  VIEWING_AREA_UNSPECIFIED: 0,
  VIEWING_AREA_DISTANT_STANDING: 1,
  VIEWING_AREA_MASKED_STANDING: 2,
  VIEWING_AREA_OPEN_STANDING: 3,
  VIEWING_AREA_NORMAL: 4
};

/**
 * @enum {number}
 */
proto.jp.singcolor.FanType = {
  FAN_TYPE_NONE: 0,
  FAN_TYPE_ASSISTANT: 1,
  FAN_TYPE_MEMBER: 2
};

/**
 * @enum {number}
 */
proto.jp.singcolor.RankingTermType = {
  RANKING_TERM_TYPE_SURGE: 0,
  RANKING_TERM_TYPE_HOUR: 1,
  RANKING_TERM_TYPE_DAY: 2,
  RANKING_TERM_TYPE_TERM: 3,
  RANKING_TERM_TYPE_NONE: 4
};

/**
 * @enum {number}
 */
proto.jp.singcolor.NotificationType = {
  NOTIFICATION_TYPE_UNKNOWN: 0,
  NOTIFICATION_TYPE_SYSTEM: 1,
  NOTIFICATION_TYPE_OPERATOR: 2
};

/**
 * @enum {number}
 */
proto.jp.singcolor.RequestStoreReviewDisplayState = {
  REQUEST_STORE_REVIEW_DISPLAY_STATE_HIDDEN: 0,
  REQUEST_STORE_REVIEW_DISPLAY_STATE_FIRST_TIME: 1,
  REQUEST_STORE_REVIEW_DISPLAY_STATE_REPEATED: 2
};

/**
 * @enum {number}
 */
proto.jp.singcolor.PearlCupDivisionHoldingStatus = {
  PEARL_CUP_DIVISION_HOLDING_STATUS_BEFORE: 0,
  PEARL_CUP_DIVISION_HOLDING_STATUS_ONGOING: 1,
  PEARL_CUP_DIVISION_HOLDING_STATUS_CALCULATING: 2,
  PEARL_CUP_DIVISION_HOLDING_STATUS_CONFIRMED: 3
};

/**
 * @enum {number}
 */
proto.jp.singcolor.AdhocEventHoldingStatus = {
  ADHOC_EVENT_HOLDING_STATUS_UNSPECIFIED: 0,
  ADHOC_EVENT_HOLDING_STATUS_BEFORE: 1,
  ADHOC_EVENT_HOLDING_STATUS_STARTED: 2,
  ADHOC_EVENT_HOLDING_STATUS_ENDED: 4
};

/**
 * @enum {number}
 */
proto.jp.singcolor.AdhocEventDivisionHoldingStatus = {
  ADHOC_EVENT_DIVISION_HOLDING_STATUS_UNSPECIFIED: 0,
  ADHOC_EVENT_DIVISION_HOLDING_STATUS_BEFORE: 1,
  ADHOC_EVENT_DIVISION_HOLDING_STATUS_ONGOING: 2,
  ADHOC_EVENT_DIVISION_HOLDING_STATUS_CALCULATING: 3,
  ADHOC_EVENT_DIVISION_HOLDING_STATUS_CONFIRMED: 4
};

/**
 * @enum {number}
 */
proto.jp.singcolor.GearType = {
  GEAR_TYPE_UNSPECIFIED: 0,
  GEAR_TYPE_2ND: 1,
  GEAR_TYPE_3RD: 2,
  GEAR_TYPE_4TH: 3,
  GEAR_TYPE_5TH: 4,
  GEAR_TYPE_ALPHA: 5,
  GEAR_TYPE_BETA: 6
};

/**
 * @enum {number}
 */
proto.jp.singcolor.IsSingFeelingAppAnswer = {
  IS_SING_FEELING_APP_STRONGLY_DISAGREE: 0,
  IS_SING_FEELING_APP_DISAGREE: 1,
  IS_SING_FEELING_APP_AGREE_SOMEWHAT: 2,
  IS_SING_FEELING_APP_AGREE: 3
};

/**
 * @enum {number}
 */
proto.jp.singcolor.CanFindGoodLiversAnswer = {
  CAN_FIND_GOOD_LIVERS_STRONGLY_DISAGREE: 0,
  CAN_FIND_GOOD_LIVERS_DISAGREE: 1,
  CAN_FIND_GOOD_LIVERS_AGREE_SOMEWHAT: 2,
  CAN_FIND_GOOD_LIVERS_AGREE: 3
};

/**
 * @enum {number}
 */
proto.jp.singcolor.DefaultTimelineID = {
  DEFAULT_TIMELINE_ID_UNSPECIFIED: 0,
  DEFAULT_TIMELINE_ID_ALL: 1,
  DEFAULT_TIMELINE_ID_TOP: 2,
  DEFAULT_TIMELINE_ID_LABEL_GROUP_TOP: 3
};

goog.object.extend(exports, proto.jp.singcolor);
